
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("5qrxS", function(module, exports) {
/* TODO(ASIMO-2105): cherrera2@ to remove 3P code once the experiment is over regardless of outcome */ 
var $42omo = parcelRequire("42omo");


var $c6GJD = parcelRequire("c6GJD");


var $dh538 = parcelRequire("dh538");


var $7dyLS = parcelRequire("7dyLS");




var $8fW0f = parcelRequire("8fW0f");

const $1ff157185fb6e44c$export$679584c8d36ab911 = (configs)=>{
    const [atlassianPlugins] = (0, $42omo.useState)(()=>new WeakMap());
    return (0, $42omo.useMemo)(()=>configs.map((config)=>{
            const existingPlugin = atlassianPlugins.get(config);
            if (existingPlugin) return existingPlugin;
            // If we haven't already created a plugin for this config, create one now
            // and store it in the map.
            const newPlugin = new (0, $8fW0f.default)(config);
            atlassianPlugins.set(config, newPlugin);
            return newPlugin;
        }), [
        atlassianPlugins,
        configs
    ]);
};


/**
 * Product key returned by /available_sites data. We are only interested in
 * 'townsquare' (Atlas), 'confluence.ondemand' or 'jira-software.ondemand' currently.
 */ const $c011f3c2795ed007$export$2db74afa1ef496f1 = [
    'jira-core.ondemand',
    'jira-incident-manager.ondemand',
    'jira-product-discovery',
    'jira-servicedesk.ondemand',
    'jira-software.ondemand',
    'confluence.ondemand',
    'townsquare',
    'loom'
];
const $c011f3c2795ed007$export$15d6fc53154f51b3 = [
    'loom',
    'jira',
    'confluence',
    'atlas',
    'townsquare'
];
const $c011f3c2795ed007$var$suportedCurrentProductMap = {
    'jira-core.ondemand': 'jira',
    'jira-incident-manager.ondemand': 'jira',
    'jira-product-discovery': 'jira',
    'jira-servicedesk.ondemand': 'jira',
    'jira-software.ondemand': 'jira',
    'confluence.ondemand': 'confluence',
    townsquare: 'atlas',
    loom: 'loom'
};
function $c011f3c2795ed007$export$40cf7a2a01d13d9d(str) {
    const strings = $c011f3c2795ed007$export$15d6fc53154f51b3;
    return strings.includes(str);
}
function $c011f3c2795ed007$export$7e250790d0036a52(product) {
    // Product may not be in supportedProducts array, that's what this is checking
    if (!(product in $c011f3c2795ed007$var$suportedCurrentProductMap)) return undefined;
    return $c011f3c2795ed007$var$suportedCurrentProductMap[product];
}






var $kiOFr = parcelRequire("kiOFr");

const $30f10d0a027e62a0$export$5afbfe6edea8e998 = (cloudId)=>{
    const { data: data, loading: isLoading } = (0, $kiOFr.useAvailableSites)();
    return {
        availableProducts: (0, $42omo.useMemo)(()=>{
            if (!data.length) return [];
            if (cloudId) return data.find((site)=>site.cloudId === cloudId)?.products ?? [];
            // Get all the products from all sites and deduplicate
            return Array.from(data.reduce((prev, curr)=>{
                return new Set([
                    ...curr.products,
                    ...Array.from(prev)
                ]);
            }, new Set()));
        }, [
            data,
            cloudId
        ]),
        isLoading: isLoading
    };
};


const $a7827c25df0a1c01$export$c0007b48d375a9ff = {
    tabConfig: {
        tabKey: 'jira',
        tabTitle: 'Jira'
    },
    products: [
        'jira'
    ],
    scope: (0, $7dyLS.Scope).JiraIssueDashboardBoardProjectFilter
};
const $a7827c25df0a1c01$export$bae28638fec080e9 = {
    ...$a7827c25df0a1c01$export$c0007b48d375a9ff,
    action: {
        // eslint-disable-next-line @atlassian/i18n/no-literal-string-in-object
        label: 'Create',
        callback: ()=>{
            console.log('Placeholder for Jira Create');
        }
    }
};
const $a7827c25df0a1c01$export$3fc43c5f39c4a529 = {
    tabConfig: {
        tabKey: 'confluence',
        tabTitle: 'Confluence'
    },
    products: [
        'confluence'
    ],
    scope: (0, $7dyLS.Scope).ConfluenceContentType
};
const $a7827c25df0a1c01$export$547f1973f56da40b = {
    tabConfig: {
        tabKey: 'atlas',
        tabTitle: 'Atlas'
    },
    products: [
        'townsquare'
    ],
    scope: (0, $7dyLS.Scope).TownsquareProject
};
const $a7827c25df0a1c01$export$32f102fef46346 = {
    tabConfig: {
        tabKey: 'home',
        tabTitle: 'Home'
    },
    products: [
        'townsquare'
    ],
    scope: (0, $7dyLS.Scope).TownsquareProject
};
const $a7827c25df0a1c01$export$b1b5e4959b6adcf2 = {
    tabConfig: {
        tabKey: 'loom',
        tabTitle: 'Loom'
    },
    products: [
        'loom'
    ],
    scope: (0, $7dyLS.Scope).Loom,
    disableActivityClient: true
};
const $a7827c25df0a1c01$export$b6c6cfc8b06bcbf4 = {
    tabConfig: {
        tabKey: 'google_drive',
        tabTitle: 'GDrive'
    },
    products: [
        'graph'
    ],
    objectTypes: [
        'document',
        'remote-link'
    ],
    dataFilter: (item)=>{
        const regex = /ari:third-party:google\.google-drive/;
        return regex.test(item.id);
    }
};
const $a7827c25df0a1c01$export$6b0117b4b22aae2 = {
    tabConfig: {
        tabKey: 'onedrive',
        tabTitle: 'OneDrive'
    },
    products: [
        'graph'
    ],
    objectTypes: [
        'document',
        'remote-link'
    ],
    dataFilter: (item)=>[
            /ari:third-party:microsoft\.onedrive/,
            /ari:third-party:microsoft\.sharepoint/
        ].some((pattern)=>pattern.test(item.id))
};
const $a7827c25df0a1c01$var$currentProductToPluginMap = {
    jira: $a7827c25df0a1c01$export$c0007b48d375a9ff,
    confluence: $a7827c25df0a1c01$export$3fc43c5f39c4a529,
    atlas: $a7827c25df0a1c01$export$547f1973f56da40b,
    loom: $a7827c25df0a1c01$export$b1b5e4959b6adcf2,
    townsquare: $a7827c25df0a1c01$export$32f102fef46346
};
const $a7827c25df0a1c01$export$ede9abe489c9321b = (config)=>{
    const { cloudId: cloudId, activityClientEndpoint: activityClientEndpoint, aggregatorUrl: aggregatorUrl } = config ?? {};
    const { availableProducts: availableProducts, isLoading: isLoading } = (0, $30f10d0a027e62a0$export$5afbfe6edea8e998)(config?.cloudId);
    /**
	 * Lower case possible name of product. Should be `confluence` or `jira`.
	 * This typing is not ideal. An unknown current product will:
	 * - in the case of no 1P tabs enabled, default to Scope.ConfluencePageBlog scope
	 * - in the case of 1P tabs enabled, not ensure the first tab is the current product
	 */ const currentProduct = config?.product?.toLowerCase();
    const createPluginConfig = (0, $42omo.useMemo)(()=>{
        return (config)=>({
                cloudId: cloudId,
                activityClientEndpoint: activityClientEndpoint,
                aggregatorUrl: aggregatorUrl,
                ...config
            });
    }, [
        cloudId,
        activityClientEndpoint,
        aggregatorUrl
    ]);
    const configMap = (0, $42omo.useMemo)(()=>{
        return {
            jira: createPluginConfig((0, $dh538.fg)('platform.linking-platform.link-picker.enable-jira-create') ? $a7827c25df0a1c01$export$bae28638fec080e9 : $a7827c25df0a1c01$var$currentProductToPluginMap.jira),
            confluence: createPluginConfig($a7827c25df0a1c01$var$currentProductToPluginMap.confluence),
            atlas: createPluginConfig($a7827c25df0a1c01$var$currentProductToPluginMap.atlas),
            townsquare: createPluginConfig($a7827c25df0a1c01$var$currentProductToPluginMap.townsquare),
            loom: createPluginConfig($a7827c25df0a1c01$var$currentProductToPluginMap.loom)
        };
    }, [
        createPluginConfig
    ]);
    return (0, $42omo.useMemo)(()=>{
        const plugins = [];
        // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
        const isLoomBetaEnabled = (0, $c6GJD.default).checkGate('confluence_loom_beta_enabled');
        // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
        const isLoomM25Enabled = (0, $c6GJD.default).checkGate('confluence_frontend_loom_cross_sell');
        // Add plugin for current product as the first tab, if we have a supported tab for it
        // We are assuming that if a product is the current product and we have a supported tab, it's in available products
        // (eg. we assume if you're in Jira, Jira will be in available products)
        if (currentProduct && (0, $c011f3c2795ed007$export$40cf7a2a01d13d9d)(currentProduct)) plugins.push(configMap[currentProduct]);
        // Experiment with new 3P tabs in link picker where 3P tabs are shown as the last tab. For more info, please see: go/link-picker-3p-drive-one-pager.
        const additionalExperimentPlugins = [];
        // Only one 3P tab can be shown at a time
        if (currentProduct === 'confluence') {
            if (((0, $c6GJD.default).initializeCalled() ? (0, $c6GJD.default).getExperimentValue('link_picker_3p_drive_experiment', 'cohort', 'control') : 'control') === 'show_google_drive_tab') additionalExperimentPlugins.push(createPluginConfig($a7827c25df0a1c01$export$b6c6cfc8b06bcbf4));
            else if (((0, $c6GJD.default).initializeCalled() ? (0, $c6GJD.default).getExperimentValue('link_picker_3p_onedrive_experiment', 'cohort', 'control') : 'control') === 'show_onedrive_tab') additionalExperimentPlugins.push(createPluginConfig($a7827c25df0a1c01$export$6b0117b4b22aae2));
        }
        return {
            isLoading: isLoading,
            atlassianPluginsConfig: [
                ...plugins,
                ...(0, $c011f3c2795ed007$export$15d6fc53154f51b3)// Exclude the current product, we've already included it above if theres a matching config available
                .filter((product)=>currentProduct !== product)// Exclude 'Atlas' tab is there is already a 'Home' tab
                .filter((product)=>{
                    if (currentProduct === 'townsquare') return product !== 'atlas';
                    return !!product;
                })// Remove any products that did not appear in the list of availableProducts
                // Does not factor in the currentProduct, that will still be in the resulting array as it
                // has been included seperately above
                .filter((product)=>product === 'loom' && isLoomBetaEnabled || availableProducts.some((availableProduct)=>product === (0, $c011f3c2795ed007$export$7e250790d0036a52)(availableProduct) && (product !== 'loom' || isLoomM25Enabled)))// Map product strings to their defined config in the config map
                .map((product)=>configMap[product]),
                ...additionalExperimentPlugins
            ]
        };
    }, [
        configMap,
        availableProducts,
        currentProduct,
        isLoading,
        createPluginConfig
    ]);
};
const $a7827c25df0a1c01$export$45a18a62e79260ff = (config)=>{
    const { atlassianPluginsConfig: atlassianPluginsConfig, isLoading: isLoading } = $a7827c25df0a1c01$export$ede9abe489c9321b(config);
    const plugins = (0, $1ff157185fb6e44c$export$679584c8d36ab911)(atlassianPluginsConfig);
    return {
        plugins: plugins,
        isLoading: isLoading
    };
};
module.exports["useLinkPickerPlugins"] = $a7827c25df0a1c01$export$45a18a62e79260ff;

});

parcelRegister("8fW0f", function(module, exports) {
/* TODO(ASIMO-2105): cherrera2@ to remove google drive code once the experiment is over regardless of outcome */ 
var $c6GJD = parcelRequire("c6GJD");

/**
 * Filters array to a set of unique items given a predicate/comparator function
 * @param arr Initial array of items
 * @param comparator Predicate function
 * @returns Array of filtered / unique items
 */ function $b8ef4b094e13b3c4$export$8437fc55448c6e05(arr, comparator) {
    return arr.filter((firstItem, index, self)=>{
        return self.findIndex((secondItem)=>comparator ? comparator(firstItem, secondItem) : firstItem === secondItem) === index;
    });
}


var $aQaGv = parcelRequire("aQaGv");


var $dh538 = parcelRequire("dh538");


var $6hu6G = parcelRequire("6hu6G");


var $7dyLS = parcelRequire("7dyLS");


var $4mvgK = parcelRequire("4mvgK");


var $7MEO5 = parcelRequire("7MEO5");


var $3paC4 = parcelRequire("3paC4");



const $2fe1ecad5a015726$var$ANALYTICS_IDENTIFIER = 'link-picker';
const $2fe1ecad5a015726$var$JIRA_DASHBOARD_URL_PATTERN = new RegExp(/(.*)\/issues\/\?dashboard=(\d+)$/);
class $2fe1ecad5a015726$export$2e2bcd8739ae039 {
    getAriString(opt) {
        try {
            return new (0, $7MEO5.ResourceIdentifier)(opt).toString();
        } catch (e) {
            return '';
        }
    }
    confluencePageBlogResponseTransformer(response) {
        if (!response) return [];
        return response.results.map((item)=>{
            const result = {
                title: item.title,
                // The `item.url` is only the relative path so we need to prefix the `item.baseUrl`
                url: item.baseUrl + item.url,
                container: item.container.title,
                contentType: this.mapToContentType(item.content && item.content.type),
                updatedTimestamp: item.lastModified,
                objectId: this.cloudIds.length === 0 ? this.getAriString({
                    resourceOwner: 'confluence',
                    cloudId: this.cloudId,
                    resourceType: this.useConfluenceTypeInAri && item.content?.type || 'content',
                    resourceId: item.content && item.content.id
                }) : item.baseUrl + item.url
            };
            if (item.subtype) result.subtype = item.subtype;
            return result;
        });
    }
    getIconUrlFromAvatar(avatar) {
        if ('urls' in avatar) return avatar.urls['16x16'];
        else return avatar.url;
    }
    jiraResponseTransformer(response) {
        if (!response) return [];
        return response.results.map((item)=>{
            // The `item.url` here for Jira content is _usually_ absolute url, except for dashboard where the url is wrong
            // It respond with https://site/issues/?dashboard={dashboardId}, but the url needs to be
            // https://site/jira/dashboards/{dashboardId}
            const dashboardMatch = $2fe1ecad5a015726$var$JIRA_DASHBOARD_URL_PATTERN.exec(item.url);
            const url = dashboardMatch ? `${dashboardMatch[1]}/jira/dashboards/${dashboardMatch[2]}` : item.url;
            return {
                title: item.name,
                url: url,
                container: 'container' in item.attributes && item.attributes.container && item.attributes.container.title || '',
                contentType: this.mapToContentType(item.attributes['@type'], 'issueTypeName' in item.attributes ? item.attributes.issueTypeName : undefined),
                updatedTimestamp: 'updated' in item.attributes ? item.attributes.updated : undefined,
                iconUrl: 'avatar' in item.attributes && item.attributes.avatar ? this.getIconUrlFromAvatar(item.attributes.avatar) : undefined,
                objectId: this.cloudIds.length === 0 ? this.getAriString({
                    resourceOwner: 'jira',
                    cloudId: this.cloudId,
                    resourceType: item.attributes['@type'],
                    resourceId: item.id
                }) : url
            };
        });
    }
    townsquareProjectResponseTransformer(response) {
        if (!response) return [];
        const townsquareResponseToQuickSearch = (item)=>{
            const { title: title, url: url, iconUrl: iconUrl } = item;
            return {
                title: title,
                url: // The `item.url` in Townsquare/Atlas response is absolute url
                url,
                iconUrl: iconUrl,
                // There isn't any container like attribute in the response
                container: '',
                contentType: this.mapToContentType('townsquareProject'),
                objectId: url
            };
        };
        return response.results.map(townsquareResponseToQuickSearch);
    }
    townsquareGoalResponseTransformer(response) {
        if (!response) return [];
        const townsquareResponseToQuickSearch = (item)=>{
            const { id: id, title: title, url: url, iconUrl: iconUrl } = item;
            return {
                title: title,
                url: // The `item.url` in Townsquare/Atlas response is absolute url
                url,
                iconUrl: iconUrl,
                // There isn't any container like attribute in the response
                container: '',
                contentType: this.mapToContentType('townsquareGoal'),
                objectId: id
            };
        };
        return response.results.map(townsquareResponseToQuickSearch);
    }
    LoomResponseTransformer(response) {
        if (!response) return [];
        return response.results.map((item)=>({
                title: item.name,
                url: item.url,
                container: item.workspaceName,
                contentType: this.mapToContentType('loom'),
                objectId: item.url,
                updatedTimestamp: item.activityDate || item.createdAt
            }));
    }
    mapToContentType(type, subType) {
        switch(type){
            case 'issue':
                switch(subType){
                    case 'Bug':
                        return 'jira.issue.bug';
                    case 'Story':
                        return 'jira.issue.story';
                    case 'Task':
                        return 'jira.issue.task';
                    case 'Epic':
                        return 'jira.issue.epic';
                    default:
                        return 'jira.issue';
                }
            case 'project':
                return 'jira.project';
            case 'board':
                return 'jira.board';
            case 'filter':
                return 'jira.filter';
            case 'dashboard':
                return 'jira.dashboard';
            case 'townsquareProject':
                return 'townsquare.project';
            case 'townsquareGoal':
                return 'townsquare.goal';
            case 'page':
                return 'confluence.page';
            case 'blogpost':
                return 'confluence.blogpost';
            case 'whiteboard':
                return 'confluence.whiteboard';
            case 'database':
                return 'confluence.database';
            case 'embed':
                return 'confluence.embed';
            case 'loom':
                return 'loom.video';
            default:
                return 'default';
        }
    }
    async quickSearch(query, limit) {
        const result = await this.client.search({
            query: query,
            scopes: [
                this.scope
            ],
            analytics: {
                identifier: this.analyticsIdentifier
            },
            resultLimit: limit,
            sites: this.cloudIds
        });
        if (this.scope === (0, $7dyLS.Scope).ConfluencePageBlog || this.scope === (0, $7dyLS.Scope).ConfluencePageBlogWhiteboard || this.scope === (0, $7dyLS.Scope).ConfluenceContentType) {
            const scopeResult = result.response.retrieveScope(this.scope);
            return this.confluencePageBlogResponseTransformer(scopeResult);
        } else if (this.scope === (0, $7dyLS.Scope).JiraIssue || this.scope === (0, $7dyLS.Scope).JiraIssueDashboardBoardProjectFilter) {
            const scopeResult = result.response.retrieveScope(this.scope);
            return this.jiraResponseTransformer(scopeResult);
        } else if (this.scope === (0, $7dyLS.Scope).TownsquareProject) {
            const scopeResult = result.response.retrieveScope(this.scope);
            return this.townsquareProjectResponseTransformer(scopeResult);
        } else if (this.scope === (0, $7dyLS.Scope).TownsquareGoal) {
            const scopeResult = result.response.retrieveScope(this.scope);
            return this.townsquareGoalResponseTransformer(scopeResult);
        } else if (this.scope === (0, $7dyLS.Scope).Loom) {
            const scopeResult = result.response.retrieveScope(this.scope);
            return this.LoomResponseTransformer(scopeResult);
        } else throw new Error(`Unsupported scope - ${this.scope}`);
    }
    constructor(cloudId, scope, aggregatorUrl, analyticsIdentifier = $2fe1ecad5a015726$var$ANALYTICS_IDENTIFIER, useConfluenceTypeInAri = false, cloudIds = []){
        this.client = void 0;
        this.scope = void 0;
        this.cloudId = void 0;
        this.cloudIds = void 0;
        this.analyticsIdentifier = void 0;
        this.useConfluenceTypeInAri = void 0;
        switch(scope){
            case (0, $7dyLS.Scope).ConfluencePageBlog:
            case (0, $7dyLS.Scope).ConfluencePageBlogWhiteboard:
            case (0, $7dyLS.Scope).ConfluenceContentType:
            case (0, $7dyLS.Scope).JiraIssue:
            case (0, $7dyLS.Scope).JiraDashboard:
            case (0, $7dyLS.Scope).JiraIssueDashboardBoardProjectFilter:
            case (0, $7dyLS.Scope).TownsquareProject:
            case (0, $7dyLS.Scope).TownsquareGoal:
            case (0, $7dyLS.Scope).Loom:
                break;
            default:
                throw new Error(`Unsupported scope - ${scope}`);
        }
        this.scope = scope;
        this.cloudId = cloudId;
        this.cloudIds = cloudIds;
        this.analyticsIdentifier = analyticsIdentifier;
        this.useConfluenceTypeInAri = useConfluenceTypeInAri;
        const config = {
            cloudId: cloudId,
            aggregatorUrl: aggregatorUrl
        };
        this.client = (0, $3paC4.createClient)(config);
    }
}



var $ilwFS = parcelRequire("ilwFS");

/* TODO(ASIMO-2105): cherrera2@ to remove google drive code once the experiment is over regardless of outcome */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $hxQwS = parcelRequire("hxQwS");


var $5pEhQ = parcelRequire("5pEhQ");


var $g30aC = parcelRequire("g30aC");


var $GLxTx = parcelRequire("GLxTx");


var $brDJd = parcelRequire("brDJd");


var $13WX1 = parcelRequire("13WX1");


var $hrqJ0 = parcelRequire("hrqJ0");


var $9wTHj = parcelRequire("9wTHj");


var $duwSm = parcelRequire("duwSm");


var $lAFHW = parcelRequire("lAFHW");





var $57Wda = parcelRequire("57Wda");


var $eQfRp = parcelRequire("eQfRp");




/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 


parcelRequire("42omo");


var $id7ja = parcelRequire("id7ja");


var $6fnsQ = parcelRequire("6fnsQ");

const $19aad91618bcf982$export$3feee2bd05046f06 = (props)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $id7ja.default), {
        ...props,
        glyph: ()=>/*#__PURE__*/ (0, $l998X.jsx)("svg", {
                width: "16",
                height: "16",
                viewBox: "0 0 16 16",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                children: /*#__PURE__*/ (0, $l998X.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M2 0C0.895431 0 0 0.895431 0 2V14C0 15.1046 0.895431 16 2 16H14C15.1046 16 16 15.1046 16 14V2C16 0.895431 15.1046 0 14 0H2ZM6.76162 3.41159C7.86083 2.11703 9.46511 1.64478 10.6195 2.27467C10.7705 2.35706 10.9977 2.49509 11.1722 2.71987C11.373 2.97851 11.4727 3.31107 11.409 3.68304C11.3524 4.01358 11.1765 4.31922 10.9546 4.60153C10.8863 4.68851 10.8097 4.77814 10.7246 4.87072C11.674 4.60241 12.5151 4.65073 13.1473 5.09225C13.9681 5.6655 14.1134 6.66452 13.9141 7.50611C13.8187 7.90918 13.4146 8.15858 13.0115 8.06316C12.6084 7.96774 12.359 7.56363 12.4545 7.16056C12.5709 6.6688 12.4237 6.41651 12.2884 6.32204C12.1286 6.21042 11.6364 6.05866 10.5554 6.52127C10.3091 6.62667 10.0224 6.63652 9.81961 6.62447C9.59851 6.61132 9.32166 6.56256 9.07282 6.44016C8.84101 6.32614 8.43506 6.03646 8.43173 5.48745C8.42884 5.01198 8.74599 4.65814 9.01233 4.43019C9.3922 4.10508 9.63128 3.85787 9.77522 3.67471C9.8072 3.63401 9.83276 3.59864 9.85315 3.56837C9.50001 3.41882 8.68015 3.4696 7.90504 4.38247C7.63694 4.69821 7.16364 4.73684 6.84789 4.46874C6.53215 4.20064 6.49352 3.72734 6.76162 3.41159ZM4.83333 9.41667C5.56971 9.41667 6.16667 8.81971 6.16667 8.08333C6.16667 7.34695 5.56971 6.75 4.83333 6.75C4.09695 6.75 3.5 7.34695 3.5 8.08333C3.5 8.81971 4.09695 9.41667 4.83333 9.41667ZM4.83333 10.9167C6.39814 10.9167 7.66667 9.64814 7.66667 8.08333C7.66667 6.51853 6.39814 5.25 4.83333 5.25C3.26853 5.25 2 6.51853 2 8.08333C2 9.64814 3.26853 10.9167 4.83333 10.9167ZM9.14834 8.88394C9.53883 8.2494 10.4612 8.2494 10.8517 8.88394L13.0621 12.4759C13.4721 13.1422 12.9928 14 12.2104 14H7.78956C7.00724 14 6.52789 13.1422 6.9379 12.4759L9.14834 8.88394ZM8.68435 12.5L10 10.3621L11.3157 12.5H8.68435Z",
                    fill: "#00A3BF"
                })
            }),
        size: "small"
    });
const $19aad91618bcf982$export$447c9c87a9a95e03 = (props)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $id7ja.default), {
        ...props,
        glyph: ()=>/*#__PURE__*/ (0, $l998X.jsx)("svg", {
                width: "16",
                height: "16",
                viewBox: "0 0 16 16",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                children: /*#__PURE__*/ (0, $l998X.jsx)("path", {
                    d: "M16 7.1H11.3L15.35 4.75L14.5 3.25L10.45 5.6L12.75 1.5L11.2 0.6L8.85 4.65V0H7.05V4.7L4.75 0.65L3.25 1.5L5.6 5.55L1.5 3.25L0.65 4.75L4.7 7.1H0V8.9H4.7L0.65 11.25L1.5 12.75L5.55 10.4L3.25 14.5L4.8 15.4L7.15 11.35V16H8.95V11.3L11.3 15.35L12.85 14.45L10.5 10.4L14.55 12.75L15.45 11.2L11.4 8.85H16V7.1ZM8 10.4C6.65 10.4 5.55 9.3 5.55 7.95C5.55 6.6 6.65 5.5 8 5.5C9.35 5.5 10.45 6.6 10.45 7.95C10.45 9.35 9.35 10.4 8 10.4Z",
                    fill: "#625DF5"
                })
            }),
        size: "small"
    });
const $19aad91618bcf982$export$edcbc8c5e08152a2 = (props)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $id7ja.default), {
        ...props,
        glyph: ()=>/*#__PURE__*/ (0, $l998X.jsx)("svg", {
                width: "16",
                height: "16",
                viewBox: "0 0 16 16",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                children: /*#__PURE__*/ (0, $l998X.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M0 2C0 0.895431 0.895431 0 2 0H14C15.1046 0 16 0.895431 16 2V14C16 15.1046 15.1046 16 14 16H2C0.895431 16 0 15.1046 0 14V2ZM3 4C3 3.44772 3.44772 3 4 3H5C5.55228 3 6 3.44772 6 4C6 4.55228 5.55228 5 5 5H4C3.44772 5 3 4.55228 3 4ZM4 7C3.44772 7 3 7.44772 3 8C3 8.55229 3.44772 9 4 9H5C5.55228 9 6 8.55229 6 8C6 7.44772 5.55228 7 5 7H4ZM3 12C3 11.4477 3.44772 11 4 11H5C5.55228 11 6 11.4477 6 12C6 12.5523 5.55228 13 5 13H4C3.44772 13 3 12.5523 3 12ZM8 3C7.44772 3 7 3.44772 7 4C7 4.55228 7.44772 5 8 5H12C12.5523 5 13 4.55228 13 4C13 3.44772 12.5523 3 12 3H8ZM7 8C7 7.44772 7.44772 7 8 7H12C12.5523 7 13 7.44772 13 8C13 8.55229 12.5523 9 12 9H8C7.44772 9 7 8.55229 7 8ZM8 11C7.44772 11 7 11.4477 7 12C7 12.5523 7.44772 13 8 13H12C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11H8Z",
                    fill: "#8270DB"
                })
            }),
        size: "small"
    });
const $19aad91618bcf982$export$1777e190ef1e8c7e = (props)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $id7ja.default), {
        ...props,
        glyph: ()=>/*#__PURE__*/ (0, $l998X.jsxs)("svg", {
                width: "16",
                height: "16",
                viewBox: "0 0 16 16",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                        width: "16",
                        height: "16",
                        rx: "3",
                        fill: "#82B536"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M8.57067 3.638L7.946 4.25133C7.88196 4.31359 7.83105 4.38805 7.79628 4.47033C7.76152 4.5526 7.7436 4.64101 7.7436 4.73033C7.7436 4.81965 7.76152 4.90806 7.79628 4.99033C7.83105 5.07261 7.88196 5.14708 7.946 5.20933C8.0764 5.33666 8.25142 5.40795 8.43367 5.40795C8.61592 5.40795 8.79095 5.33666 8.92134 5.20933L9.57734 4.56533C10.222 3.932 11.272 3.80866 11.9787 4.37333C12.1677 4.52241 12.3227 4.71006 12.4334 4.92377C12.5442 5.13749 12.6081 5.37236 12.6209 5.61272C12.6337 5.85308 12.5951 6.09341 12.5077 6.31768C12.4203 6.54196 12.2861 6.74502 12.114 6.91333L10.1787 8.81466C9.84918 9.1362 9.40705 9.31618 8.94667 9.31618C8.48629 9.31618 8.04416 9.1362 7.71467 8.81466L6.97467 8.088L6 9.04666L6.73867 9.77266C7.95334 10.9647 9.94 10.9647 11.1533 9.77266L13.09 7.87133C13.3971 7.56973 13.6367 7.20631 13.7928 6.80515C13.9489 6.40399 14.018 5.97424 13.9955 5.54437C13.973 5.1145 13.8594 4.69431 13.6623 4.31164C13.4651 3.92897 13.189 3.59255 12.852 3.32466C11.59 2.31333 9.722 2.50733 8.57067 3.638Z",
                        fill: `var(--ds-icon-inverse, ${(0, $6fnsQ.N0)})`
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M7.42934 13.0287L8.054 12.4153C8.11805 12.3531 8.16896 12.2786 8.20373 12.1963C8.23849 12.1141 8.2564 12.0256 8.2564 11.9363C8.2564 11.847 8.23849 11.7586 8.20373 11.6763C8.16896 11.5941 8.11805 11.5196 8.054 11.4573C7.92364 11.3302 7.74876 11.259 7.56667 11.259C7.38458 11.259 7.2097 11.3302 7.07934 11.4573L6.42267 12.1013C5.778 12.7347 4.728 12.858 4.02134 12.2933C3.83236 12.1443 3.67733 11.9566 3.56659 11.7429C3.45585 11.5292 3.39195 11.2943 3.37914 11.0539C3.36633 10.8136 3.40492 10.5733 3.49232 10.349C3.57972 10.1247 3.71393 9.92164 3.886 9.75333L5.82134 7.852C6.15083 7.53046 6.59296 7.35048 7.05334 7.35048C7.51371 7.35048 7.95585 7.53046 8.28534 7.852L9.02534 8.57866L10 7.62L9.26134 6.894C8.04667 5.702 6.06 5.702 4.84667 6.894L2.91 8.79533C2.60286 9.09693 2.36331 9.46035 2.20721 9.86151C2.05111 10.2627 1.98202 10.6924 2.00452 11.1223C2.02702 11.5522 2.1406 11.9724 2.33773 12.355C2.53487 12.7377 2.81105 13.0741 3.148 13.342C4.41 14.3533 6.278 14.1593 7.42934 13.0287Z",
                        fill: `var(--ds-icon-inverse, ${(0, $6fnsQ.N0)})`
                    })
                ]
            }),
        size: "small"
    });


/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $abC4X = parcelRequire("abC4X");


var $2Nwuj = parcelRequire("2Nwuj");


var $kiOFr = parcelRequire("kiOFr");


var $kSC7A = parcelRequire("kSC7A");




/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 


parcelRequire("42omo");




const $c4f341a96ee4101f$var$noResultsSVGStyles = null;
const $c4f341a96ee4101f$export$88f98178b806da03 = ()=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 96 96",
        className: (0, $gMc0m.default)([
            "_1bsb16xz _4t3i16xz _19pkidpf _2hwx1wug _otyrpxbi _18u01wug _1e0c1ule"
        ]),
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                fill: "#FCA700",
                d: "M74.189 55.386c.318-1.787.485-3.69.485-5.697a32.59 32.59 0 0 0-.496-5.774c-1.933-10.773-9.418-17.412-19.912-19.12-1.79-.29-3.669-.44-5.62-.44s-3.994.161-5.854.472c-10.5 1.752-17.971 8.375-19.909 19.088a32.362 32.362 0 0 0-.5 5.774c0 2.039.169 3.91.49 5.697 1.923 10.7 9.4 17.333 19.919 19.089 1.86.31 3.815.471 5.854.471s3.83-.15 5.62-.44c10.512-1.71 18.003-8.36 19.923-19.12Z"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                fill: "#1868DB",
                d: "M40.02 77.477c-.248 6.944 3.225 9.59 8.598 9.59 5.044 0 8.434-2.646 8.434-9.59V69.54H40.02v7.938Z"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                fill: "#101214",
                d: "M50.807 58.42c-.07.901-.133 1.802-.175 2.702 0 0-.035.29-.077.758a42.187 42.187 0 0 0-.146 1.808c-.088 1.404-.119 3.044-.021 3.98a81.585 81.585 0 0 0 .14 7.037s.062.734.174 1.571c.108.838.255 1.784.377 2.214.147.537.283.876.377.939.206.125.181-.862-.14-3.655.007-.035.007-.15.021-.164-.38-2.954-.248-5.83-.21-8.85-.052.039-.09-.063-.059-.157l.063.035c-.073-2.021.206-3.264.144-5.121 0 0 .066.216.066.22.122-1.571.314-3.292.576-5.052.136-.851.377-1.703.914-2.251.27-.276.615-.485.964-.562.349-.077.691-.014.97.188.283.2.507.53.618.901.056.185.087.377.087.566 0 .195-.024.397-.07.596-.184.8-.708 1.564-1.284 2.228a9.32 9.32 0 0 1-2.01 1.665c-.748.43-1.533.76-2.322.995h.035l-.01.014c.15-.032.44-.102.792-.192.335-.13.754-.245 1.113-.437.182-.09.367-.167.527-.258l.426-.255c.252-.143.395-.258.395-.258-.796.796-1.92 1.354-3.11 1.64-1.194.29-2.444.322-3.624.213l.024-.08c1.016.098 1.924-.042 2.273-.129-.9.105-2.05.112-3.257-.164-.597-.147-1.218-.328-1.805-.621-.147-.07-.293-.144-.443-.213l-.42-.262a4.987 4.987 0 0 1-.785-.573c-.474-.433-.88-.953-1.138-1.5a3.304 3.304 0 0 1-.258-.832 2.151 2.151 0 0 1 .038-.782c.143-.488.458-.88.866-1.078.402-.213.859-.266 1.257-.245-.038-.038-.31-.038-.594-.003-.279.038-.565.112-.715.084.74-.356 1.69-.283 2.426.059-.028.06-.143.035-.262-.007-.122-.031-.251-.077-.297-.08.144.073.754.223 1.362.83.286.3.586.751.803 1.285.22.541.373 1.184.454 1.896.083.712.097 1.487.09 2.307 0 .82-.017 1.672-.056 2.542a91.086 91.086 0 0 1-.373 5.257c-.339 3.453-.785 6.622-.992 8.486-.209 1.864-.195 2.416.213.618l.042.196c.308-1.875.559-3.428.946-5.373.025-.279.042-.31-.024-.317 0-.074-.004-.2-.038-.171-.168.007-.028-.597 0-.866.237.195.443-1.33.551-3.016.115-1.683.108-3.523.136-3.952.262-.157.077-1.69.185-2.206.007.038.063.268.07.3.042-.115.06-.684.042-1.435-.01-.747-.056-1.69-.196-2.541-.254-1.718-1.096-2.912-.436-1.97a4.525 4.525 0 0 0-.967-1.608 3.86 3.86 0 0 0-1.83-1.006 3.41 3.41 0 0 0-1.12-.094 2.874 2.874 0 0 0-1.155.321c-.37.196-.698.496-.936.859a2.7 2.7 0 0 0-.405 1.225c-.07.883.27 1.704.723 2.395.227.349.503.663.8.956.296.287.635.566.99.772l.531.325c.182.097.374.181.563.272.37.195.778.3 1.169.447.806.213 1.637.384 2.478.39l.315.015.314-.01.628-.029.622-.08.31-.042.308-.066.61-.136.597-.189.297-.094.29-.119.572-.24c1.487-.727 2.814-1.778 3.718-3.104.45-.657.828-1.407.911-2.245.087-.841-.188-1.71-.796-2.314-.303-.3-.712-.52-1.141-.59a2.392 2.392 0 0 0-1.232.129c-.744.283-1.32.845-1.673 1.46l.067-.06c-.056.073-.16.324-.217.37a7.214 7.214 0 0 0-.258 1.016c-.07.39-.119.81-.157 1.19l-.133 1.39-.003-.008Zm-4.675 3.376s-.014.01-.007.014c0-.014-.314-.063-.635-.108a8.793 8.793 0 0 1-.66-.154l.028-.077c.629.12 1.655.315 2.196.416.272.06.422.08.325.105-.098.028-.447.003-1.145-.105-.098.007-.091-.063-.105-.094l.003.003Zm-4.726-7.128c.213-.07.453-.126.719-.14a2.898 2.898 0 0 0-1.061.401c-.329.213-.597.52-.772.887-.373.733-.265 1.655.108 2.426.374.779.957 1.47 1.655 1.976.175.126.363.23.541.346l.272.167c.095.05.189.091.283.137.189.087.377.174.566.254.195.063.387.123.576.185-.573.018-1.47-.324-2.28-.872-.824-.566-1.435-1.418-1.735-2.053-.366-.6-.572-1.445-.342-2.217.119-.377.332-.712.593-.97.259-.266.587-.42.88-.52l-.003-.007ZM45.944 70.1l.042.01-.01.102s-.025-.014-.029-.035a.14.14 0 0 1-.003-.077Zm5.26-13.182c-.041-.223.147-1.022.179-.464-.05.133-.046.538-.178.464Zm-6.678-1.63c.039-.06.283.073.475.272.2.196.315.444.241.496a4.06 4.06 0 0 0-.715-.768Zm6.078 9.51c.133.286-.028.198-.122.29.025-.07.042-.326.108-.27l.014-.02Zm0 4.953c.074.07.122.349.13.482-.046.342-.19-.325-.13-.482Zm.527 8.14c.08 0 .13.193.056.256-.063-.014-.133-.245-.045-.287 0 0-.01.014-.01.032Zm-5.058-18.204c-.13-.133-.164-.433-.199-.761-.031-.328-.073-.685-.164-.915.126.024.202.265.244.552.042.286.046.61.084.799.014.136.025.24.032.321l.003.004Zm9.635-4.217c-.105.007-.119-.22-.182-.482-.056-.265-.185-.559-.296-.663l.07-.046c.279.374.44.674.408 1.173v.021-.003Zm-15.158.576c.014.097-.031.195-.066.303-.028.109-.08.217-.077.307-.028 0-.052-.052-.06-.125 0-.07.008-.164.025-.255.06-.171.14-.314.182-.234l-.004.004Zm5.254 5.264c.025.133-.394.017-.513-.01.09 0 .258-.05.36-.039.07.01.083.028.153.049Zm9.97-5.474a3.445 3.445 0 0 1-.363 1.18l-.07-.049c.182-.373.308-.76.35-1.152l.08.018.003.003Zm-2.203 3.327-.055-.063c.363-.464.558-.366.066.053l-.01.01Zm-.984-4.776c.042-.038.108-.1.147-.14.29-.264.276-.146.178-.02-.098.125-.248.3-.328.16h.003Zm-1.065 4.2c0 .087.014.206 0 .297-.08.607-.202-.091 0-.297ZM38.864 13.967l-.233-.314s-.112-.65-.392-.828l-.254-.946s-.189-.366-.353-.44a.488.488 0 0 0-.29-.041c-.17.038-.265.216-.073.565-.007.007-.014.028-.028.035.262.35.185.8.353 1.19.045-.02.09-.02.07 0l-.063.018c.216.223.08.457.373.628h-.09c.335.82.656 1.98 1.075 2.845l.007-.007h.01c.032-.104-.024-.537-.024-.537.401.195.216.646.342.96l-.08.024a.659.659 0 0 0-.179-.286c.07.534.405 1.536.699 1.969.055-.035-.13-.136.052-.241.045.122.119.234.154.35-.126.044-.105-.04-.133-.043-.066.248 1.229 4.336 1.42 3.184h.074c-.06-.258-.112-.471-.077-.775-.024-.032-.01-.042-.077-.018-.014-.006-.038-.017-.062 0-.157.06-.123-.041-.14-.076.506-.13-.237-.824-.258-.943.227-.105-.07-.223.003-.328.01 0 .073.014.084.014.13-.115-.646-.97-.255-.785.07-1.358-1.288-3.296-1.316-4.727l-.024.02s-.021-.038.01-.059c-.14-.094-.328-.401-.328-.401l.003-.007Zm.768 3.034s.014 0 .014-.004c-.024.01.05.168.046.178l-.077.028c-.21-.112.185-.684.084-.237.024.007-.042.028-.067.041v-.006Zm.514 1.462c0 .032.007.063.014.101-.381-.293-.259-.91-.52-1.288.397.018.334.423.376.608.144.153.123.398.13.576v.003Zm.81 2.465.041-.014v.014s-.02.007-.024.007c-.01 0-.018 0-.014-.007h-.004Zm-2.203-6.696c.073.007.073.123-.074.098.014-.024-.063-.056.074-.098Zm1.448 4.692c.13-.045.203.084.028.147-.02-.046-.024-.098-.028-.147Zm-1.951-5.68c-.15.01.007-.031.087-.073-.014.018-.01.052-.077.066l-.01.007Zm-.314-.621c-.07.014-.126-.007-.136-.024.035-.063.188-.018.136.024Zm-.391-1.068c-.077.024-.112.007-.039-.025.056-.017.112 0 .025.035 0 0 .01-.003.014-.01Zm2.611 8.11c-.237.041-.101-.151-.185-.196.23-.063.108.115.164.153a.229.229 0 0 0 .021.042Zm-1.445-4.235c-.2.073-.091-.126-.15-.157l.077-.028c.045.063.111.087.073.181v.004Zm.918 2.96c-.087 0-.032-.07-.042-.098.112-.038.171.07.038.098h.004Zm-.391-1.194c.119-.049.08.031.098.042-.028 0-.112 0-.115-.01 0-.011.01-.018.017-.032Zm-.433-1.742a1.4 1.4 0 0 1 .056.171l-.08.025a4.814 4.814 0 0 1-.056-.171l.08-.025Zm.077.6-.077.029c-.101-.056.094-.133.077-.028Zm-.423-1.284v.031c.05.112-.293.053 0-.031Zm-.29-.573s-.045-.014-.045-.028c-.02-.083.203-.062.046.028ZM51.327 14.843l-.007-.303s.28-.416.164-.67c.115-.22.237-.433.356-.65 0 0 .073-.304-.003-.44a.52.52 0 0 0-.196-.202c-.153-.087-.328-.053-.394.251-.01 0-.025.007-.042 0-.01.346-.335.541-.433.855.049.014.084.042.052.039l-.059-.028c.038.248-.206.3-.07.565l-.07-.052c-.206.65-.586 1.498-.694 2.238h.017c.08-.05.265-.332.265-.332.227.325-.164.492-.22.75l-.08-.024a.409.409 0 0 0 0-.262c-.223.356-.45 1.142-.412 1.55.063.004-.042-.143.164-.125-.02.097-.014.199-.038.29-.13-.032-.073-.074-.094-.088-.088.06-.356.89-.468 1.63-.112.74-.087 1.376.244 1.027l.067.028c.059-.196.104-.357.272-.538-.007-.031.007-.031-.06-.042a.093.093 0 0 0-.055-.028c-.164-.024-.091-.077-.091-.108.506.122.16-.628.199-.716.248.032.042-.174.157-.206.007.007.06.039.066.046.16-.014-.1-.894.15-.604.353-.405.482-1.047.632-1.704.147-.653.321-1.32.702-1.72h-.032s.008-.036.042-.029c-.059-.125-.041-.401-.041-.401l.01.003Zm-1.002 2.137.014.003c-.024-.007-.045.126-.052.13l-.08-.025c-.116-.175.506-.314.191-.101.018.014-.049-.004-.076-.01l.003.003Zm-.304 1.134c-.014.021-.024.042-.038.07-.185-.36.23-.68.203-1.033.32.206.07.415.01.551.045.161-.09.3-.178.412h.003Zm-.453 1.906.041.007v.01s-.028-.006-.03-.01c-.008 0-.015-.007-.011-.01v.003Zm1.522-5.093c.055.046-.01.112-.112.014.024-.007-.017-.066.112-.014Zm-1.243 3.498c.133.031.136.147-.049.105.007-.039.028-.07.049-.105ZM51.25 14.1c-.122-.08.025-.014.112.01-.021 0-.038.021-.098-.007h-.014V14.1Zm.115-.52c-.062-.035-.09-.08-.09-.095.063-.014.153.102.09.095Zm.332-.796c-.073-.035-.087-.063-.014-.035.052.028.084.07 0 .035h.014Zm-2.248 6.084c-.227-.08-.014-.14-.066-.21.23.064.034.123.07.172 0 .014-.004.024 0 .035l-.004.003Zm.946-3.288c-.2-.066-.004-.122-.035-.175l.077.028c0 .063.042.112-.042.143v.004Zm-.779 2.245c-.076-.042.01-.06.014-.08.116.027.112.125-.014.08Zm.276-.925c.126.03.053.059.06.076-.025-.017-.095-.056-.091-.066.003-.007.017-.003.031-.01Zm.566-1.254a.961.961 0 0 1-.046.13l-.076-.028c.014-.046.031-.088.045-.13l.077.028Zm-.262.388-.08-.025c-.056-.087.15-.028.08.025Zm.36-.97s-.018.013-.018.017c-.02.09-.265-.133.018-.018Zm.087-.486s-.028-.031-.021-.042c.031-.06.195.08.02.042ZM62.638 15.643l.17-.367s.528-.43.552-.768l.726-.708s.238-.353.227-.535a.489.489 0 0 0-.101-.279c-.115-.132-.321-.122-.541.224-.01 0-.028 0-.042-.007-.189.408-.628.572-.897.918.042.031.063.066.035.06l-.046-.046c-.097.303-.373.303-.384.649l-.042-.08c-.572.712-1.459 1.588-2.035 2.401h.01l.008.011c.108-.028.467-.293.467-.293.014.453-.474.52-.698.792l-.06-.056c.102-.111.165-.237.172-.303-.443.335-1.18 1.141-1.428 1.62.056.03.06-.182.237-.077-.087.1-.153.223-.237.314-.101-.087-.017-.112-.028-.14-.251.066-3.295 3.299-2.171 2.877l.035.066c.202-.185.37-.339.66-.464.017-.039.031-.032-.021-.077 0-.014-.004-.042-.028-.056-.126-.108-.021-.13 0-.164.36.38.621-.628.719-.709.202.147.167-.178.297-.164l.027.08c.165.056.559-1.064.584-.624 1.25-.632 2.335-2.821 3.606-3.575l-.028-.01s.028-.039.059-.021c.017-.172.203-.493.203-.493l-.008.004Zm-2.35 2.223s.007.011.01.011c-.02-.017-.125.13-.136.13l-.062-.057c0-.24.701-.185.254-.049.007.025-.045-.02-.07-.038l.004.003Zm-1.068 1.201a.653.653 0 0 0-.084.063c.08-.485.691-.694.904-1.117.175.36-.22.51-.363.646-.066.202-.3.314-.454.408h-.003Zm-1.815 1.973.031.028-.01.01s-.018-.017-.021-.024c-.004-.007-.007-.018 0-.018v.004Zm4.94-5.362c.03.07-.078.129-.123-.014.032 0 .021-.084.122.014Zm-3.51 3.676c.102.09.022.223-.118.097.032-.041.077-.07.119-.097Zm4.155-4.622c-.084-.126.032-.01.108.038-.02-.007-.052.018-.097-.035l-.01-.007v.004Zm.408-.594c-.045-.056-.052-.115-.041-.129.073 0 .104.157.041.13Zm.768-.89c-.059-.052-.059-.094.004-.045.042.042.056.097-.017.038 0 0 .01.007.013.007Zm-6.014 6.44c-.15-.188.087-.163.087-.265.168.172-.052.154-.06.224-.013.014-.02.028-.027.038v.004Zm3.1-3.434c-.161-.14.07-.143.07-.213l.062.056c-.035.073-.024.143-.129.157h-.003Zm-2.214 2.321c-.041-.077.05-.063.067-.084.087.08.017.189-.07.084h.003Zm.887-.953c.101.08.01.087.01.108-.01-.028-.055-.097-.045-.108.007-.007.021 0 .035 0Zm1.351-1.27c-.038.045-.084.094-.126.14l-.059-.057c.042-.045.084-.094.126-.136l.059.056v-.004Zm-.5.37-.062-.056c0-.12.164.014.063.052v.003Zm.947-1.027s-.025.01-.028.018c-.077.1-.185-.23.028-.018Zm.373-.548s-.007-.045 0-.056c.067-.06.15.147 0 .056Z"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                fill: "#09326C",
                d: "M40.02 69.542v4.336a31.13 31.13 0 0 0 2.771.597c1.861.31 3.816.471 5.855.471 2.038 0 3.83-.15 5.62-.44a30.493 30.493 0 0 0 2.786-.586v-4.378H40.02Z"
            })
        ]
    });
};


const $6b6b665bcf70315b$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    noResults: {
        id: "fabric.linkPickerAtlassianPlugin.emptyStateNoResults.heading",
        defaultMessage: "Get started with {productName}."
    },
    noResultsConfluenceDescription: {
        id: "fabric.linkPickerAtlassianPlugin.emptyStateNoResults.confluenceDescription",
        defaultMessage: "Recently viewed pages will appear once you <link>start using Confluence</link>."
    },
    noResultsJiraDescription: {
        id: "fabric.linkPickerAtlassianPlugin.emptyStateNoResults.jiraDescription",
        defaultMessage: "Recently viewed issues will appear once you <link>start using Jira</link>."
    },
    noResultsJiraDescriptionIssueTerminologyRefreshM4: {
        id: "fabric.linkPickerAtlassianPlugin.emptyStateNoResults.jiraDescription-issue-terminology-refresh-m4",
        defaultMessage: "Recently viewed work items will appear once you <link>start using Jira</link>."
    },
    noResultsDefaultDescription: {
        id: "fabric.linkPickerAtlassianPlugin.emptyStateNoResults.defaultDescription",
        defaultMessage: "Recently viewed items will appear once you <link>start using {productName}</link>."
    },
    noResultsConfluenceCreateOption: {
        id: "fabric.linkPickerAtlassianPlugin.emptyStateNoResults.description",
        defaultMessage: "You can also create a new page."
    }
});
const $6b6b665bcf70315b$export$800daf5fbbe96aff = {
    emptyStateNoResults: 'link-picker-empty-state-no-results'
};
const $6b6b665bcf70315b$var$emptyStateWrapperStyles = null;
const $6b6b665bcf70315b$export$e661eeb828fb7b2 = ({ product: product, action: action, cloudId: cloudId, isMultisiteSearch: isMultisiteSearch })=>{
    const intl = (0, $8C5kA.default)();
    const { data: data } = (0, $kiOFr.useAvailableSites)();
    const isConfluence = product === 'confluence'; // confluence has some special cases
    const productDetails = $6b6b665bcf70315b$export$dc8a6c8f6bc81cdd(product);
    if (!productDetails) return null; // unsupported product
     // find the first matching site for this product
    const firstMatchingSite = data.find($6b6b665bcf70315b$export$5e557b52f4095909(productDetails.availableSitesProduct, cloudId, isMultisiteSearch));
    if (firstMatchingSite) {
        let baseUrl = firstMatchingSite.url; // Confluence is a special case where the baseUrl is the same as Jira's, so we need to add the path
        if (isConfluence) baseUrl += '/wiki';
        const intlDescription = intl.formatMessage(productDetails.description, {
            productName: productDetails.productName,
            link: (str)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $2Nwuj.default), {
                    href: baseUrl,
                    children: str
                })
        }); // Confluence is a special case because it has an optional "create", which we'll list as a call to action
        const intlConfCreate = isConfluence ? intl.formatMessage($6b6b665bcf70315b$export$defe85febe8b728c.noResultsConfluenceCreateOption) : '';
        return /*#__PURE__*/ (0, $l998X.jsx)("div", {
            className: (0, $gMc0m.default)([
                "_otyrmgjw _clfdidpf _11pqidpf _q0a5idpf _c3k8idpf"
            ]),
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $abC4X.default), {
                testId: $6b6b665bcf70315b$export$800daf5fbbe96aff.emptyStateNoResults,
                header: intl.formatMessage($6b6b665bcf70315b$export$defe85febe8b728c.noResults, {
                    productName: productDetails.productName
                }),
                description: /*#__PURE__*/ (0, $l998X.jsxs)("span", {
                    children: [
                        intlDescription,
                        " ",
                        intlConfCreate
                    ]
                }),
                renderImage: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $c4f341a96ee4101f$export$88f98178b806da03), {})
            })
        });
    }
    return null;
};
const $6b6b665bcf70315b$export$dc8a6c8f6bc81cdd = (product)=>{
    switch(product){
        case 'confluence':
            return {
                availableSitesProduct: (0, $kSC7A.AvailableSitesProductType).CONFLUENCE,
                productName: 'Confluence',
                description: $6b6b665bcf70315b$export$defe85febe8b728c.noResultsConfluenceDescription
            };
        case 'jira':
            return {
                availableSitesProduct: (0, $kSC7A.AvailableSitesProductType).JIRA_SOFTWARE,
                productName: 'Jira',
                description: (0, $dh538.fg)('jira-issue-terminology-update-m4') ? $6b6b665bcf70315b$export$defe85febe8b728c.noResultsJiraDescriptionIssueTerminologyRefreshM4 : $6b6b665bcf70315b$export$defe85febe8b728c.noResultsJiraDescription
            };
        case 'atlas':
            return {
                availableSitesProduct: (0, $kSC7A.AvailableSitesProductType).ATLAS,
                productName: 'Atlas',
                description: $6b6b665bcf70315b$export$defe85febe8b728c.noResultsDefaultDescription
            };
        default:
            return undefined;
    }
};
const $6b6b665bcf70315b$export$5e557b52f4095909 = (availableSitesProduct, cloudId, isMultisiteSearch)=>{
    return (site)=>{
        // if the product doesn't match, this site doesn't match
        if (!site.products.includes(availableSitesProduct)) return false;
         // if the cloudId is undefined, this site matches (match everything)
        if (!cloudId) return true;
         // if we're mutlisite, match everything - this is probably a mistake,
        // but I'm not going to fix that here, and sticking to consistency with AtlassianLinkPickerPlugin.getRecentItems
        if (isMultisiteSearch) return true;
         // otherwise the site has to match the cloudId
        return site.cloudId === cloudId;
    };
};





const $930927a24c397c44$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    hyperlinkIconIssueLabel: {
        id: "fabric.linkPicker.headingLink.hyperlinkIconIssueLabel",
        defaultMessage: "Issue"
    },
    hyperlinkIconBugLabel: {
        id: "fabric.linkPicker.headingLink.hyperlinkIconBugLabel",
        defaultMessage: "Bug"
    },
    hyperlinkIconStoryLabel: {
        id: "fabric.linkPicker.headingLink.hyperlinkIconStoryLabel",
        defaultMessage: "Story"
    },
    hyperlinkIconTaskLabel: {
        id: "fabric.linkPicker.headingLink.hyperlinkIconTaskLabel",
        defaultMessage: "Task"
    },
    hyperlinkIconEpicLabel: {
        id: "fabric.linkPicker.headingLink.hyperlinkIconEpicLabel",
        defaultMessage: "Epic"
    },
    hyperlinkIconDashboardLabel: {
        id: "fabric.linkPicker.headingLink.hyperlinkIconDashboardLabel",
        defaultMessage: "Dashboard"
    },
    hyperlinkIconBoardLabel: {
        id: "fabric.linkPicker.headingLink.hyperlinkIconBoardLabel",
        defaultMessage: "Board"
    },
    hyperlinkIconProjectLabel: {
        id: "fabric.linkPicker.headingLink.hyperlinkIconProjectLabel",
        defaultMessage: "Task"
    },
    hyperlinkIconPlanLabel: {
        id: "fabric.linkPicker.headingLink.hyperlinkIconPlanLabel",
        defaultMessage: "Plan"
    },
    hyperlinkIconFilterLabel: {
        id: "fabric.linkPicker.headingLink.hyperlinkIconFilterLabel",
        defaultMessage: "Filter"
    },
    hyperlinkIconPageLabel: {
        id: "fabric.linkPicker.headingLink.hyperlinkIconPageLabel",
        defaultMessage: "Page"
    },
    hyperlinkIconBlogLabel: {
        id: "fabric.linkPicker.headingLink.hyperlinkIconBlogLabel",
        defaultMessage: "Blog"
    },
    hyperlinkIconWhiteboardLabel: {
        id: "fabric.linkPicker.headingLink.hyperlinkIconWhiteboardLabel",
        defaultMessage: "Whiteboard"
    },
    hyperlinkIconDatabaseLabel: {
        id: "fabric.linkPicker.headingLink.hyperlinkIconDatabaseLabel",
        defaultMessage: "Database"
    },
    hyperlinkIconEmbedLabel: {
        id: "fabric.linkPicker.headingLink.hyperlinkIconEmbedLabel",
        defaultMessage: "Smart Link"
    },
    hyperlinkIconLoomLabel: {
        id: "fabric.linkPicker.headingLink.hyperlinkIconLoomLabel",
        defaultMessage: "Loom"
    },
    hyperlinkIconLiveDocLabel: {
        id: "fabric.linkPicker.headingLink.hyperlinkIconLiveDocLabel",
        defaultMessage: "Live Doc"
    },
    story: {
        id: "fabric.linkPicker.story",
        defaultMessage: "Story"
    },
    epic: {
        id: "fabric.linkPicker.epic",
        defaultMessage: "Epic"
    },
    task: {
        id: "fabric.linkPicker.task",
        defaultMessage: "Task"
    },
    bug: {
        id: "fabric.linkPicker.bug",
        defaultMessage: "Bug"
    },
    subTask: {
        id: "fabric.linkPicker.subTask",
        defaultMessage: "Sub-task"
    },
    improvement: {
        id: "fabric.linkPicker.improvement",
        defaultMessage: "Improvement"
    },
    defaultAltText: {
        id: "fabric.linkPicker.defaultAltText",
        defaultMessage: "List item"
    },
    hyperlinkIconIssueLabelIssueTermRefresh: {
        id: "fabric.linkPicker.headingLink.hyperlinkIconIssueLabel-issue-term-refresh",
        defaultMessage: "Work item"
    }
});



var $6YhrE = parcelRequire("6YhrE");


var $4kI6d = parcelRequire("4kI6d");

var $0d10d22313e2a678$var$LinkContentType = /*#__PURE__*/ function(LinkContentType) {
    LinkContentType[LinkContentType["jira.issue"] = 0] = "jira.issue";
    LinkContentType[LinkContentType["jira.issue.bug"] = 1] = "jira.issue.bug";
    LinkContentType[LinkContentType["jira.issue.story"] = 2] = "jira.issue.story";
    LinkContentType[LinkContentType["jira.issue.task"] = 3] = "jira.issue.task";
    LinkContentType[LinkContentType["jira.issue.epic"] = 4] = "jira.issue.epic";
    LinkContentType[LinkContentType["jira.dashboard"] = 5] = "jira.dashboard";
    LinkContentType[LinkContentType["jira.board"] = 6] = "jira.board";
    LinkContentType[LinkContentType["jira.project"] = 7] = "jira.project";
    LinkContentType[LinkContentType["jira.filter"] = 8] = "jira.filter";
    LinkContentType[LinkContentType["confluence.page"] = 9] = "confluence.page";
    LinkContentType[LinkContentType["confluence.blogpost"] = 10] = "confluence.blogpost";
    LinkContentType[LinkContentType["confluence.whiteboard"] = 11] = "confluence.whiteboard";
    LinkContentType[LinkContentType["loom.video"] = 12] = "loom.video";
    LinkContentType[LinkContentType["confluence.database"] = 13] = "confluence.database";
    LinkContentType[LinkContentType["confluence.embed"] = 14] = "confluence.embed";
    return LinkContentType;
}($0d10d22313e2a678$var$LinkContentType || {});
const $0d10d22313e2a678$export$74b0c6644317c84d = (product, action, cloudId, isMultisiteSearch)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $6b6b665bcf70315b$export$e661eeb828fb7b2), {
        product: product,
        action: action,
        cloudId: cloudId,
        isMultisiteSearch: isMultisiteSearch
    });
};
const $0d10d22313e2a678$export$f642707b43bbbafc = (contentType)=>{
    return Boolean(contentType && Object.keys($0d10d22313e2a678$var$LinkContentType).includes(contentType));
};
const $0d10d22313e2a678$export$80e948449ec854a9 = {
    'jira.issue': {
        icon: ({ alt: alt })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $GLxTx.default), {
                label: alt
            }),
        iconAlt: (0, $930927a24c397c44$export$defe85febe8b728c).hyperlinkIconIssueLabel
    },
    'jira.issue.bug': {
        icon: ({ alt: alt })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $5pEhQ.default), {
                label: alt
            }),
        iconAlt: (0, $930927a24c397c44$export$defe85febe8b728c).hyperlinkIconBugLabel
    },
    'jira.issue.story': {
        icon: ({ alt: alt })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $hrqJ0.default), {
                label: alt
            }),
        iconAlt: (0, $930927a24c397c44$export$defe85febe8b728c).hyperlinkIconStoryLabel
    },
    'jira.issue.task': {
        icon: ({ alt: alt })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $9wTHj.default), {
                label: alt
            }),
        iconAlt: (0, $930927a24c397c44$export$defe85febe8b728c).hyperlinkIconTaskLabel
    },
    'jira.issue.epic': {
        icon: ({ alt: alt })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $g30aC.default), {
                label: alt
            }),
        iconAlt: (0, $930927a24c397c44$export$defe85febe8b728c).hyperlinkIconEpicLabel
    },
    'jira.dashboard': {
        icon: ({ alt: alt })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $lAFHW.JiraIcon), {
                label: alt,
                size: "xxsmall",
                appearance: "brand",
                ...(0, $dh538.fg)('navx-1895-new-logo-design') ? {
                    shouldUseNewLogoDesign: true
                } : undefined
            }),
        iconAlt: (0, $930927a24c397c44$export$defe85febe8b728c).hyperlinkIconDashboardLabel
    },
    'jira.board': {
        icon: ({ alt: alt })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $lAFHW.JiraIcon), {
                label: alt,
                size: "xxsmall",
                appearance: "brand",
                ...(0, $dh538.fg)('navx-1895-new-logo-design') ? {
                    shouldUseNewLogoDesign: true
                } : undefined
            }),
        iconAlt: (0, $930927a24c397c44$export$defe85febe8b728c).hyperlinkIconBoardLabel
    },
    'jira.project': {
        icon: ({ alt: alt })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $lAFHW.JiraIcon), {
                label: alt,
                size: "xxsmall",
                appearance: "brand",
                ...(0, $dh538.fg)('navx-1895-new-logo-design') ? {
                    shouldUseNewLogoDesign: true
                } : undefined
            }),
        iconAlt: (0, $930927a24c397c44$export$defe85febe8b728c).hyperlinkIconProjectLabel
    },
    'jira.filter': {
        icon: ({ alt: alt })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $lAFHW.JiraIcon), {
                label: alt,
                size: "xxsmall",
                appearance: "brand",
                ...(0, $dh538.fg)('navx-1895-new-logo-design') ? {
                    shouldUseNewLogoDesign: true
                } : undefined
            }),
        iconAlt: (0, $930927a24c397c44$export$defe85febe8b728c).hyperlinkIconFilterLabel
    },
    'confluence.page': {
        icon: ({ alt: alt })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $13WX1.default), {
                label: alt
            }),
        iconAlt: (0, $930927a24c397c44$export$defe85febe8b728c).hyperlinkIconPageLabel
    },
    'confluence.blogpost': {
        icon: ({ alt: alt })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $hxQwS.default), {
                label: alt
            }),
        iconAlt: (0, $930927a24c397c44$export$defe85febe8b728c).hyperlinkIconBlogLabel
    },
    'confluence.whiteboard': {
        icon: ({ alt: alt })=>(0, $dh538.fg)('navx-1959-link-picker-remove-custom-icons') ? /*#__PURE__*/ (0, $l998X.jsx)((0, $eQfRp.default), {
                label: alt
            }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $19aad91618bcf982$export$3feee2bd05046f06), {
                label: alt
            }),
        iconAlt: (0, $930927a24c397c44$export$defe85febe8b728c).hyperlinkIconWhiteboardLabel
    },
    'loom.video': {
        icon: ({ alt: alt })=>(0, $dh538.fg)('navx-1959-link-picker-remove-custom-icons') ? /*#__PURE__*/ (0, $l998X.jsx)((0, $lAFHW.LoomIcon), {
                label: alt,
                shouldUseNewLogoDesign: true,
                size: "xxsmall"
            }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $19aad91618bcf982$export$447c9c87a9a95e03), {
                label: alt
            }),
        iconAlt: (0, $930927a24c397c44$export$defe85febe8b728c).hyperlinkIconLoomLabel
    },
    'confluence.database': {
        icon: ({ alt: alt })=>(0, $dh538.fg)('navx-1959-link-picker-remove-custom-icons') ? /*#__PURE__*/ (0, $l998X.jsx)((0, $57Wda.default), {
                label: alt
            }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $19aad91618bcf982$export$edcbc8c5e08152a2), {
                label: alt
            }),
        iconAlt: (0, $930927a24c397c44$export$defe85febe8b728c).hyperlinkIconDatabaseLabel
    },
    'confluence.embed': {
        icon: ({ alt: alt })=>(0, $dh538.fg)('navx-1959-link-picker-remove-custom-icons') ? /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($duwSm))), {
                color: "var(--ds-icon-accent-blue, #357DE8)",
                label: alt
            }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $19aad91618bcf982$export$1777e190ef1e8c7e), {
                label: alt
            }),
        iconAlt: (0, $930927a24c397c44$export$defe85febe8b728c).hyperlinkIconEmbedLabel
    }
};
const $0d10d22313e2a678$export$d71678bb4eba5b81 = (contentType, subtype)=>{
    if (!$0d10d22313e2a678$export$f642707b43bbbafc(contentType)) return {
        icon: ({ alt: alt })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $13WX1.default), {
                label: alt
            }),
        iconAlt: (0, $930927a24c397c44$export$defe85febe8b728c).defaultAltText
    };
    if (contentType === 'jira.issue' && (0, $dh538.fg)('confluence-issue-terminology-refresh')) return {
        icon: ({ alt: alt })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $GLxTx.default), {
                label: alt
            }),
        iconAlt: (0, $930927a24c397c44$export$defe85febe8b728c).hyperlinkIconIssueLabelIssueTermRefresh
    };
    if (contentType === 'confluence.page' && subtype === 'live') return {
        icon: ({ alt: alt })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $brDJd.default), {
                label: alt
            }),
        iconAlt: (0, $930927a24c397c44$export$defe85febe8b728c).hyperlinkIconLiveDocLabel
    };
    return $0d10d22313e2a678$export$80e948449ec854a9[contentType];
};
const $0d10d22313e2a678$export$ac1fda7301622804 = (iconUrl)=>{
    let alt = (0, $930927a24c397c44$export$defe85febe8b728c).defaultAltText;
    // TODO add in extra cases for V3 api
    if (iconUrl.includes('story.svg')) alt = (0, $930927a24c397c44$export$defe85febe8b728c).story;
    if (iconUrl.includes('epic.svg')) alt = (0, $930927a24c397c44$export$defe85febe8b728c).epic;
    if (iconUrl.includes('avatarId=10318')) alt = (0, $930927a24c397c44$export$defe85febe8b728c).task;
    if (iconUrl.includes('avatarId=10303')) alt = (0, $930927a24c397c44$export$defe85febe8b728c).bug;
    if (iconUrl.includes('avatarId=10518')) alt = (0, $930927a24c397c44$export$defe85febe8b728c).subTask;
    if (iconUrl.includes('avatarId=10310')) alt = (0, $930927a24c397c44$export$defe85febe8b728c).improvement;
    return alt;
};
const $0d10d22313e2a678$export$fd251dec3e575ea1 = (iconUrl)=>{
    return {
        icon: iconUrl,
        iconAlt: $0d10d22313e2a678$export$ac1fda7301622804(iconUrl)
    };
};







function $13b92bff3b95cf64$export$8437fc55448c6e05(arr, comparator) {
    return arr.filter((firstItem, index, self)=>{
        return self.findIndex((secondItem)=>comparator ? comparator(firstItem, secondItem) : firstItem === secondItem) === index;
    });
}
const $13b92bff3b95cf64$export$d82137ca931458ca = ({ object: object, containers: containers, timestamp: timestamp })=>{
    let iconUrl = object.icon?.value || '';
    if (object.icon?.type === 'EMOJI') iconUrl = object.icon.fallback || '';
    const iconData = object.product === 'confluence' ? (0, $0d10d22313e2a678$export$d71678bb4eba5b81)(object.product + '.' + object.type.toLowerCase(), object.subtype?.toLowerCase()) : (0, $0d10d22313e2a678$export$fd251dec3e575ea1)(iconUrl);
    return {
        objectId: object.id,
        name: object.name || '',
        container: $13b92bff3b95cf64$var$getContainerName(containers),
        url: object.url,
        ...iconData,
        lastViewedDate: timestamp ? new Date(timestamp) : undefined,
        prefetch: true,
        meta: {
            source: 'recent-work'
        }
    };
};
const $13b92bff3b95cf64$export$16c4c0987c894b8c = (items, searchTerm)=>{
    if (!searchTerm || !items) return [];
    return items.filter((item)=>{
        return item.name.toLowerCase().indexOf(searchTerm.toLowerCase()) > -1;
    });
};
const $13b92bff3b95cf64$export$b76efb0c656bea6e = ({ objectId: objectId, container: container, title: title, contentType: contentType, url: url, updatedTimestamp: updatedTimestamp, iconUrl: iconUrl, subtype: subtype })=>({
        objectId: objectId,
        name: title,
        container: container,
        url: url,
        ...// which return defaultAlt if no icon is found. Otherwise find an icon by looking up the content type
        iconUrl ? {
            icon: iconUrl,
            iconAlt: (0, $0d10d22313e2a678$export$d71678bb4eba5b81)(contentType, subtype).iconAlt
        } : (0, $0d10d22313e2a678$export$d71678bb4eba5b81)(contentType, subtype),
        lastUpdatedDate: updatedTimestamp ? new Date(updatedTimestamp) : undefined,
        prefetch: false,
        meta: {
            source: 'xp-search'
        }
    });
const $13b92bff3b95cf64$var$getContainerName = (containers)=>{
    for(let i = containers.length - 1; i >= 0; --i){
        const containerName = containers[i].name;
        if (containerName) return containerName;
    }
    return '';
};
/** No results returned for townsquare (Atlas) if `platform` is used in filter
 * https://atlassian.slack.com/archives/CGZMUTRUL/p1684729057252109?thread_ts=1684727786.451419&cid=CGZMUTRUL
 */ /**
 * Generate the ARI for particular product to send to the recent items API.
 */ function $13b92bff3b95cf64$var$generateProductSpecificAri(product, cloudId) {
    if (product === 'townsquare') /** No results returned for townsquare (Atlas) if `platform` is used in filter
		 * https://atlassian.slack.com/archives/CGZMUTRUL/p1684729057252109?thread_ts=1684727786.451419&cid=CGZMUTRUL
		 */ return `ari:cloud:townsquare::site/${cloudId}`;
    return `ari:cloud:platform::site/${cloudId}`;
}
function $13b92bff3b95cf64$export$4b7ffcf66d37c47b(products, cloudId) {
    const defaultAri = `ari:cloud:platform::site/${cloudId}`;
    if (products === undefined) return [
        defaultAri
    ];
    const allAris = products.map((product)=>$13b92bff3b95cf64$var$generateProductSpecificAri(product, cloudId));
    // Deduplicate
    return allAris.filter((value, index)=>allAris.indexOf(value) === index);
}


const $072a50f740811d00$export$452f1062ecf44be7 = 5;
const $072a50f740811d00$var$DEBOUNCE_MS = 400;
/**
 * Plugin responsible for handling fetching + caching of Atlassian Link Picker results
 */ class $072a50f740811d00$var$AtlassianLinkPickerPlugin {
    /**
   * Create search provider if config params are provided
   */ createSearchProvider(scope, aggregatorUrl, analyticsIdentifier, useConfluenceTypeInAri) {
        if (!this.cloudId || !scope) return undefined;
        return Promise.resolve(new (0, $2fe1ecad5a015726$export$2e2bcd8739ae039)(this.cloudId, scope, aggregatorUrl, analyticsIdentifier, useConfluenceTypeInAri, this.cloudIds));
    }
    /**
   * Filter out fields from recent or search items.
   * @param items The recent items to remove fields from.
   * @returns Items with fields removed.
   */ filterListItemFields(items) {
        // Assume this.products won't change during function call
        const products = this.products;
        // We can't filter out items if we don't have a product or we have more than one product,
        // as we can't tell which product a given item is from.
        if (products?.length !== 1) return items;
        // Config of map of products to fields to filter out from each item
        const productFieldsMap = {
            townsquare: [
                'lastViewedDate',
                'lastUpdatedDate',
                'container'
            ]
        };
        return items.map((item)=>{
            const newItem = {
                ...item
            };
            // Set fields to be undefined when they have been specified to be based on a given product in productFieldsMap
            for (const [productToCheck, fieldsToCheck] of Object.entries(productFieldsMap)){
                if (products[0] === productToCheck) for (const field of fieldsToCheck)newItem[field] = undefined;
            }
            return newItem;
        });
    }
    /**
   * Set lastUpdatedDate for Loom search results and unset lastViewedDate.
   * @param items The recent Loom items .
   * @returns Items with lastUpdatedDate set.
   */ setLoomRecentItemsDateField(items) {
        return items.map((item)=>{
            const newItem = {
                ...item
            };
            newItem.lastViewedDate = item.lastUpdatedDate;
            newItem.lastUpdatedDate = undefined;
            return newItem;
        });
    }
    /**
   * Retrieve recent items from the activity provider
   */ async getRecentItems() {
        if (!this.activityClient) return [];
        if (!this.recentItems) {
            const { viewed: items } = await this.activityClient.fetchActivities([
                50,
                125,
                250
            ], // retries
            {
                limit: 100,
                objectTypes: this.objectTypes,
                products: this.products,
                rootContainerIds: this.allowMultiSiteRecents ? this.cloudIds?.reduce((acc, cloudId)=>acc.concat(...(0, $13b92bff3b95cf64$export$4b7ffcf66d37c47b)(this.products, cloudId)), []) : // If cloudIds array is provided, do not scope activities query
                this.cloudId !== undefined && !this.isMultisiteSearch ? (0, $13b92bff3b95cf64$export$4b7ffcf66d37c47b)(this.products, this.cloudId) : undefined
            }, [
                'viewed'
            ], true);
            this.recentItems = items.map((0, $13b92bff3b95cf64$export$d82137ca931458ca));
            this.recentItems = this.filterListItemFields(this.recentItems);
        }
        return this.recentItems;
    }
    /**
   * Given a query, search the activity provider for recent activity
   */ async searchRecentItems({ query: query }) {
        if (!this.recentItems) await this.getRecentItems();
        return (0, $13b92bff3b95cf64$export$16c4c0987c894b8c)(this.recentItems, query);
    }
    async quickSearch(state) {
        const isLoomRecentSearch = this._scope === (0, $7dyLS.Scope).Loom && state.query.length === 0;
        // similar to getRecentItems() we return the initial recent result when query string is reset
        if (isLoomRecentSearch && this._loomRecentItems) return this._loomRecentItems;
        const items = await this.debouncedSearch(state.query);
        let searchListItems = items.map((0, $13b92bff3b95cf64$export$b76efb0c656bea6e));
        // For Loom both recent and search results are fetched from search client. When search query is empty
        // the search returns recent items, when the query is not empty it returns searched items.
        // The setLoomRecentItemsDateField method sets the correct date field for the UI to consume.
        if (isLoomRecentSearch) {
            searchListItems = this.setLoomRecentItemsDateField(searchListItems);
            this._loomRecentItems = searchListItems;
        }
        return this.filterListItemFields(searchListItems);
    }
    /**
   * Merge list of recent items and search items, and dedupes
   */ mergeResults(itemsA, itemsB) {
        // Dedupe the items based on the URL
        return (0, $b8ef4b094e13b3c4$export$8437fc55448c6e05)([
            ...itemsA,
            ...itemsB
        ], (itemA, itemB)=>itemA.url === itemB.url);
    }
    applyPluginFilter(items) {
        return items.filter(({ objectId: objectId })=>this._pluginItemFilter?.(objectId) ?? true).filter(({ objectId: objectId, url: url })=>this._pluginDataFilter?.({
                id: objectId,
                url: url
            }) ?? true);
    }
    isGoogleDriveExperimentEnabled() {
        const linkPicker3pDriveExperimentCohort = (0, $c6GJD.default).initializeCalled() ? (0, $c6GJD.default).getExperimentValue('link_picker_3p_drive_experiment', 'cohort', 'control') : 'control';
        return linkPicker3pDriveExperimentCohort === 'show_google_drive_tab';
    }
    isGoogleDriveExperimentEnabledAndIsGoogleDriveTab() {
        return this.isGoogleDriveExperimentEnabled() && this.tabKey.toLowerCase() === 'google_drive';
    }
    isOneDriveExperimentEnabled() {
        const linkPicker3pDriveExperimentCohort = (0, $c6GJD.default).initializeCalled() ? (0, $c6GJD.default).getExperimentValue('link_picker_3p_onedrive_experiment', 'cohort', 'control') : 'control';
        return linkPicker3pDriveExperimentCohort === 'show_onedrive_tab';
    }
    isOneDriveExperimentEnabledAndIsOneDriveTab() {
        return this.isOneDriveExperimentEnabled() && this.tabKey.toLowerCase() === 'onedrive';
    }
    /**
   * Given link picker state yields updates to the list of link picker results
   * The plugin is considered to be in a loading state until the generator returns a final value
   * The plugin can yield intermediate lists of results to present the user with initial results
   * while loading additional results to update the list with.
   */ async *resolve(state) {
        if (this.activityClient && state.query.length === 0) {
            // If the user has not authorized we will show the empty state for Google Drive. Otherwise, we attempt to fetch recent items.
            if (this.isGoogleDriveExperimentEnabledAndIsGoogleDriveTab()) {
                const googleDriveConfigurationStatus = (0, $ilwFS.getGoogleDriveConnectionStatus)();
                const userHasAuthorizedGoogleDriveConnector = googleDriveConfigurationStatus ? googleDriveConfigurationStatus.isUserOAuthed : await (0, $4mvgK.checkIfUserHasAuthorizedGoogleDriveConnector)(this.cloudId);
                return {
                    data: userHasAuthorizedGoogleDriveConnector ? this.applyPluginFilter(await this.getRecentItems()) : []
                };
            }
            // If the user has not authorized we will show the empty state for OneDrive. Otherwise, we attempt to fetch recent items.
            if (this.isOneDriveExperimentEnabledAndIsOneDriveTab()) {
                const oneDriveConfigurationStatus = (0, $ilwFS.getOneDriveConnectionStatus)();
                const userHasAuthorizedOneDriveConnector = oneDriveConfigurationStatus ? oneDriveConfigurationStatus.isUserOAuthed : await (0, $4mvgK.checkIfUserHasAuthorizedOneDriveConnector)(this.cloudId);
                return {
                    data: userHasAuthorizedOneDriveConnector ? this.applyPluginFilter(await this.getRecentItems()) : []
                };
            }
            return {
                data: this.applyPluginFilter(await this.getRecentItems())
            };
        }
        // Filter recents based on current state
        const filteredRecentItems = this.applyPluginFilter(await this.searchRecentItems(state));
        // If we have enough results, or there's no search provider to fetch more, return what we have
        if (filteredRecentItems.length >= $072a50f740811d00$export$452f1062ecf44be7 || !this.searchProvider) return {
            data: filteredRecentItems
        };
        if (filteredRecentItems.length) // Update with what we have while we search for more
        yield {
            data: filteredRecentItems
        };
        // Get more results and return them merged with recents
        const searchResults = this.applyPluginFilter(await this.quickSearch(state));
        return {
            data: this.mergeResults(filteredRecentItems, searchResults)
        };
    }
    emptyStateNoResults() {
        if (this.isGoogleDriveExperimentEnabledAndIsGoogleDriveTab()) return (0, $4kI6d.renderGoogleDriveEmptyState)();
        else if (this.isOneDriveExperimentEnabledAndIsOneDriveTab()) return (0, $4kI6d.renderOneDriveEmptyState)();
        if ((0, $dh538.fg)('link-picker-atl-plugin-empty-state')) {
            if (!this.activityClient) return null; // recent activity isn't supported, so leave this as blank
            if (!this.products || this.products.length !== 1) // don't support multi-product, as message gets too confusing
            return null;
            return (0, $0d10d22313e2a678$export$74b0c6644317c84d)(this.products[0], this.action, this.cloudId, this.isMultisiteSearch);
        }
        return null;
    }
    get tabKey() {
        return this._tabKey;
    }
    get tabTitle() {
        return this._tabTitle;
    }
    get action() {
        return this._action;
    }
    get banner() {
        return this._pluginBanner;
    }
    constructor(config){
        this._tabKey = void 0;
        this._tabTitle = void 0;
        this.products = void 0;
        this.debouncedSearch = void 0;
        this.searchProvider = void 0;
        this.activityClient = void 0;
        this.recentItems = void 0;
        this.analyticsIdentifier = 'link-picker-quick-search';
        this.useConfluenceTypeInAri = true;
        this.cloudId = void 0;
        this.cloudIds = void 0;
        this.isMultisiteSearch = void 0;
        this.allowMultiSiteRecents = void 0;
        this._action = void 0;
        this._scope = void 0;
        this._loomRecentItems = void 0;
        this._pluginItemFilter = void 0;
        this._pluginDataFilter = void 0;
        this.objectTypes = void 0;
        this._pluginBanner = void 0;
        const { tabConfig: tabConfig, activityClientEndpoint: activityClientEndpoint, disableActivityClient: disableActivityClient = false, searchProvider: searchProvider, cloudId: cloudId, cloudIds: cloudIds, scope: scope, products: products, aggregatorUrl: aggregatorUrl, action: action, itemFilter: itemFilter, dataFilter: dataFilter, allowMultiSiteRecents: allowMultiSiteRecents, objectTypes: objectTypes } = config ?? {};
        const { tabKey: tabKey, tabTitle: tabTitle } = tabConfig ?? {};
        this._tabKey = tabKey || 'Atlassian';
        this._tabTitle = tabTitle || 'Atlassian';
        this.products = products;
        this.cloudId = cloudId;
        this.cloudIds = cloudIds;
        this.isMultisiteSearch = (this.cloudIds?.length ?? 0) > 0;
        this.allowMultiSiteRecents = this.isMultisiteSearch && allowMultiSiteRecents;
        this._action = action;
        this._scope = scope;
        this._pluginItemFilter = itemFilter;
        this._pluginDataFilter = dataFilter;
        this.objectTypes = objectTypes;
        this.searchProvider = searchProvider || this.createSearchProvider(scope, aggregatorUrl, this.analyticsIdentifier, this.useConfluenceTypeInAri);
        if (!disableActivityClient) this.activityClient = (0, $6hu6G.createActivityClient)('v3', 'link_picker_atlassian_plugin', undefined, activityClientEndpoint);
        this.debouncedSearch = (0, $aQaGv.promiseDebounce)(async (query)=>{
            if (!this.searchProvider) return [];
            const searchProvider = await this.searchProvider;
            return searchProvider.quickSearch(query, $072a50f740811d00$export$452f1062ecf44be7);
        }, $072a50f740811d00$var$DEBOUNCE_MS);
        if (this.isGoogleDriveExperimentEnabled()) this._pluginBanner = ()=>(0, $6YhrE.renderGoogleDriveConnectBanner)(this.cloudId || null);
        else if (this.isOneDriveExperimentEnabled()) this._pluginBanner = ()=>(0, $6YhrE.renderOneDriveConnectBanner)(this.cloudId || null);
    }
}
var $072a50f740811d00$export$2e2bcd8739ae039 = $072a50f740811d00$var$AtlassianLinkPickerPlugin;
module.exports["default"] = $072a50f740811d00$export$2e2bcd8739ae039;

});

parcelRegister("aQaGv", function(module, exports) {
/**
 * Given a callback function returns a promise that resolves to the result of calling the callback function but is
 * debounced (execution is cancelled and promise will remain pending if `promiseDebounce` is re-called within the `time` interval)
 * @param cb Callback which returns result to be resolved
 * @param time Debounce interval
 * @returns Function that returns debounced promise
 */ function $b114f862ee74d165$export$390f1673aa3d5232(cb, time) {
    let timeoutId;
    // Returns a promise that fires the debounce fn and pushes a resolver
    // to have the debounced result resolved
    return (...args)=>{
        timeoutId && clearTimeout(timeoutId);
        return new Promise((resolve, reject)=>{
            timeoutId = setTimeout(()=>{
                cb(...args).then(resolve).catch(reject);
            }, time);
        });
    };
}
module.exports["promiseDebounce"] = $b114f862ee74d165$export$390f1673aa3d5232;

});

parcelRegister("6YhrE", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* TODO(ASIMO-2105): cherrera2@ to remove google drive code once the experiment is over regardless of outcome */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $inPa6 = parcelRequire("inPa6");


var $1qfLF = parcelRequire("1qfLF");


var $1Whri = parcelRequire("1Whri");


var $hmuev = parcelRequire("hmuev");


var $d8SNb = parcelRequire("d8SNb");

var $u9agA = parcelRequire("u9agA");

var $fVUfS = parcelRequire("fVUfS");


var $94Xzi = parcelRequire("94Xzi");


var $4mvgK = parcelRequire("4mvgK");


var $9HfcQ = parcelRequire("9HfcQ");


var $ilwFS = parcelRequire("ilwFS");


var $aAc08 = parcelRequire("aAc08");

const $6df7f64a9c2aebda$export$d3fb3fda844d5e5e = 'google-drive-connect-banner-close-button';
const $6df7f64a9c2aebda$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    thirdPartyConnectBannerLink: {
        id: "fabric.linkPickerAtlassianPlugin.thirdPartyConnectBannerLink",
        defaultMessage: "Connect your apps to see more links"
    },
    thirdPartyConnectBannerClose: {
        id: "fabric.linkPickerAtlassianPlugin.thirdPartyConnectBannerClose",
        defaultMessage: "Dismiss"
    }
});
const $6df7f64a9c2aebda$var$styles = {
    containerBaseStyles: "_2rko12b0 _bfhki8nm _yv0e5ifu _19pku2gc _ca0qutpp _u5f3utpp _n3tdutpp _19bvutpp",
    pressableInlineStyles: "_19bvu2gc",
    pressableStyles: "_11c81o8v _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _syaz13af _k48p1wq8",
    closeButtonContainer: "_10fph9n0"
};
const $6df7f64a9c2aebda$var$GoogleDriveIcon = ()=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "#FFFFFF",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                x: "0.254162",
                y: "0.254162",
                width: "15.4917",
                height: "15.4917",
                rx: "3.74584",
                stroke: "#0B1228",
                strokeOpacity: "0.14",
                strokeWidth: "0.508324"
            }),
            /*#__PURE__*/ (0, $l998X.jsxs)("g", {
                clipPath: "url(#clip0_303_5302)",
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M3.4728 11.3855L3.9432 12.1939C4.04095 12.3641 4.18146 12.4978 4.34641 12.595L6.02644 9.70197H2.66638C2.66638 9.89038 2.71526 10.0788 2.813 10.249L3.4728 11.3855Z",
                        fill: "#0066DA"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M7.99972 6.29837L6.31968 3.4053C6.15474 3.50255 6.01422 3.63626 5.91648 3.80644L2.813 9.15497C2.71705 9.32148 2.66651 9.51005 2.66638 9.70198H6.02644L7.99972 6.29837Z",
                        fill: "#00AC47"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M11.6534 12.595C11.8183 12.4978 11.9588 12.3641 12.0566 12.1939L12.2521 11.8596L13.1868 10.249C13.2845 10.0788 13.3334 9.89038 13.3334 9.70197H9.97308L10.6881 11.0999L11.6534 12.595Z",
                        fill: "#EA4335"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M7.99998 6.29846L9.68001 3.40539C9.51506 3.30814 9.32567 3.25952 9.13018 3.25952H6.86977C6.67428 3.25952 6.48489 3.31422 6.31995 3.40539L7.99998 6.29846Z",
                        fill: "#00832D"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M9.97271 9.70197H6.02616L4.34613 12.595C4.51108 12.6923 4.70046 12.7409 4.89596 12.7409H11.1029C11.2984 12.7409 11.4878 12.6862 11.6527 12.595L9.97271 9.70197Z",
                        fill: "#2684FC"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M11.6352 6.48071L10.0834 3.80644C9.98567 3.63626 9.84516 3.50255 9.68021 3.4053L8.00018 6.29837L9.97346 9.70198H13.3274C13.3274 9.51357 13.2785 9.32515 13.1808 9.15497L11.6352 6.48071Z",
                        fill: "#FFBA00"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("defs", {
                children: /*#__PURE__*/ (0, $l998X.jsx)("clipPath", {
                    id: "clip0_303_5302",
                    children: /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                        width: "10.6667",
                        height: "9.48148",
                        fill: "white",
                        transform: "translate(2.6662 3.2594)"
                    })
                })
            })
        ]
    });
};
const $6df7f64a9c2aebda$var$OneDriveIcon = ()=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $l998X.jsxs)("g", {
                clipPath: "url(#clip0_1_445)",
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M6.57592 6.13485L6.57604 6.13444L9.09516 7.64336L10.5963 7.01167C10.9013 6.8798 11.2302 6.81218 11.5625 6.8125C11.6179 6.8125 11.6726 6.81502 11.727 6.81865C11.5466 6.11493 11.1656 5.47878 10.6304 4.9875C10.0952 4.49622 9.42882 4.17097 8.71226 4.05126C7.9957 3.93156 7.25979 4.02256 6.59397 4.3132C5.92815 4.60385 5.36108 5.08162 4.96167 5.68847C4.9745 5.68831 4.98714 5.6875 5 5.6875C5.55675 5.68675 6.10261 5.8417 6.57592 6.13485Z",
                        fill: "#0364B8"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M6.57603 6.13444L6.57592 6.13485C6.1026 5.8417 5.55674 5.68675 5 5.68751C4.98714 5.68751 4.97448 5.68831 4.96166 5.68847C4.41675 5.69522 3.88398 5.85033 3.4206 6.13712C2.95722 6.42392 2.58074 6.83156 2.33164 7.31625C2.08253 7.80094 1.97021 8.34434 2.00675 8.88807C2.04328 9.4318 2.22729 9.95529 2.53899 10.4023L4.76049 9.46745L5.74803 9.05188L7.94685 8.12658L9.09515 7.64336L6.57603 6.13444Z",
                        fill: "#0078D4"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M11.727 6.81865C11.6726 6.81502 11.6179 6.8125 11.5625 6.8125C11.2302 6.81218 10.9013 6.88005 10.5963 7.01192L9.09515 7.64336L9.53044 7.90409L10.9573 8.75876L11.5798 9.13165L13.7084 10.4067C13.9019 10.0476 14.0021 9.64577 14 9.23793C13.9978 8.8301 13.8934 8.42932 13.6963 8.0723C13.4991 7.71528 13.2155 7.41344 12.8715 7.19442C12.5274 6.9754 12.134 6.84619 11.727 6.81865Z",
                        fill: "#1490DF"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M11.5798 9.13164L10.9573 8.75875L9.53045 7.90408L9.09516 7.64335L7.94686 8.12657L5.74803 9.05187L4.7605 9.46744L2.539 10.4023C2.81506 10.7992 3.18308 11.1234 3.61163 11.3472C4.04018 11.571 4.51653 11.6877 5 11.6875H11.5625C12.0025 11.6876 12.4343 11.5686 12.8122 11.3431C13.19 11.1176 13.4997 10.794 13.7085 10.4067L11.5798 9.13164Z",
                        fill: "#28A8EA"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("defs", {
                children: /*#__PURE__*/ (0, $l998X.jsx)("clipPath", {
                    id: "clip0_1_445",
                    children: /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                        width: "12",
                        height: "12",
                        fill: "white",
                        transform: "translate(2 2)"
                    })
                })
            })
        ]
    });
};
var $6df7f64a9c2aebda$var$ThirdPartyConnectBannerSource = /*#__PURE__*/ function(ThirdPartyConnectBannerSource) {
    ThirdPartyConnectBannerSource["GOOGLE_DRIVE"] = "google_drive";
    ThirdPartyConnectBannerSource["ONE_DRIVE"] = "onedrive";
    return ThirdPartyConnectBannerSource;
}($6df7f64a9c2aebda$var$ThirdPartyConnectBannerSource || {});
const $6df7f64a9c2aebda$var$ThirdPartySourceMapping = {
    ["google_drive"]: {
        fetchBannerStatusFromLocalStorage: (0, $ilwFS.getGoogleDriveConnectionBannerStatus),
        bannerStatusStorageKey: (0, $ilwFS.GOOGLE_DRIVE_CONNECTION_BANNER_STORAGE_KEY),
        connectorCheckMethod: (cloudId)=>(0, $4mvgK.checkIfUserHasAuthorizedGoogleDriveConnector)(cloudId),
        fetchConnectionStatusFromLocalStorage: (0, $ilwFS.getGoogleDriveConnectionStatus),
        connectionStatusStorageKey: (0, $ilwFS.GOOGLE_DRIVE_CONNECTION_STATUS_STORAGE_KEY),
        icon: /*#__PURE__*/ (0, $l998X.jsx)($6df7f64a9c2aebda$var$GoogleDriveIcon, {}),
        tab: 'google_drive'
    },
    ["onedrive"]: {
        fetchBannerStatusFromLocalStorage: (0, $ilwFS.getOneDriveConnectionBannerStatus),
        bannerStatusStorageKey: (0, $ilwFS.ONE_DRIVE_CONNECTION_BANNER_STORAGE_KEY),
        connectorCheckMethod: (cloudId)=>(0, $4mvgK.checkIfUserHasAuthorizedOneDriveConnector)(cloudId),
        fetchConnectionStatusFromLocalStorage: (0, $ilwFS.getOneDriveConnectionStatus),
        connectionStatusStorageKey: (0, $ilwFS.ONE_DRIVE_CONNECTION_STATUS_STORAGE_KEY),
        icon: /*#__PURE__*/ (0, $l998X.jsx)($6df7f64a9c2aebda$var$OneDriveIcon, {}),
        tab: 'onedrive'
    }
};
const $6df7f64a9c2aebda$var$ThirdPartyConnectBanner = ({ cloudId: cloudId, source: source })=>{
    const { bannerStatusStorageKey: bannerStatusStorageKey, connectorCheckMethod: connectorCheckMethod, connectionStatusStorageKey: connectionStatusStorageKey, fetchBannerStatusFromLocalStorage: fetchBannerStatusFromLocalStorage, fetchConnectionStatusFromLocalStorage: fetchConnectionStatusFromLocalStorage, icon: icon, tab: tab } = $6df7f64a9c2aebda$var$ThirdPartySourceMapping[source];
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const [integrationDetails, setIntegrationDetails] = (0, $9HfcQ.useBrowserStorage)(connectionStatusStorageKey, fetchConnectionStatusFromLocalStorage());
    const [bannerDismissState, setBannerDismissState] = (0, $9HfcQ.useBrowserStorage)(bannerStatusStorageKey, fetchBannerStatusFromLocalStorage());
    const hasBannerBeenDismissed = bannerDismissState?.hasBannerBeenDismissed || false;
    const hasAuthorized = integrationDetails?.isUserOAuthed || false;
    const hasIntegrationDetails = Object.keys(integrationDetails || {}).length > 0;
    const hideBanner = hasAuthorized || hasBannerBeenDismissed || !hasIntegrationDetails;
    const trackEvent = (event)=>{
        createAnalyticsEvent(event).fire((0, $94Xzi.ANALYTICS_CHANNEL));
    };
    const handleBroadcastedOAuthSuccess = (_)=>{
        setBannerDismissState({
            hasBannerBeenDismissed: true
        });
    }; // If the user has authorized through the empty state UI, close the banner.
    (0, $42omo.useEffect)(()=>{
        window.addEventListener((0, $aAc08.THIRD_PARTY_OAUTH_SUCCESS_EVENT), handleBroadcastedOAuthSuccess);
        return ()=>{
            window.removeEventListener((0, $aAc08.THIRD_PARTY_OAUTH_SUCCESS_EVENT), handleBroadcastedOAuthSuccess);
        }; // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const handleConnectionClick = ()=>{
        if (!integrationDetails || !integrationDetails.outboundAuthUrl) return;
        trackEvent((0, $94Xzi.buildAuthClickedEventPayload)((0, $94Xzi.ThirdPartyAuthSource).CONNECT_BANNER, tab));
        (0, $aAc08.triggerThirdPartyAuthFlow)(integrationDetails.outboundAuthUrl).then(()=>{
            setIntegrationDetails({
                ...integrationDetails,
                isUserOAuthed: true,
                expirationDate: Date.now() + (0, $ilwFS.DEFAULT_EXPIRATION_FOR_3P_CONNECTION_STATUS)
            });
            trackEvent((0, $94Xzi.buildAuthCompletedEventPayload)((0, $94Xzi.ThirdPartyAuthSource).CONNECT_BANNER, tab));
        }).catch((_)=>{
            trackEvent((0, $94Xzi.buildAuthFailedEventPayload)((0, $94Xzi.ThirdPartyAuthSource).CONNECT_BANNER, tab));
        });
    }; // Fetch connection status if it hasn't been fetched yet and the banner hasn't been dismissed
    (0, $42omo.useEffect)(()=>{
        const fetchThirdPartyConnectionStatus = async ()=>{
            await connectorCheckMethod(cloudId);
            setIntegrationDetails(fetchConnectionStatusFromLocalStorage());
        };
        if (!integrationDetails && !hasBannerBeenDismissed) fetchThirdPartyConnectionStatus();
    }, [
        cloudId,
        integrationDetails,
        hasBannerBeenDismissed,
        setIntegrationDetails,
        connectorCheckMethod,
        fetchConnectionStatusFromLocalStorage
    ]); // If the user has authorized or the banner has been dismissed, don't render the banner
    if (hideBanner) return null;
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $d8SNb.default), {
        alignItems: "center",
        xcss: (0, $1Whri.cx)($6df7f64a9c2aebda$var$styles.containerBaseStyles),
        children: [
            icon,
            /*#__PURE__*/ (0, $l998X.jsx)((0, $u9agA.default), {
                alignBlock: "center",
                xcss: $6df7f64a9c2aebda$var$styles.pressableInlineStyles,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $fVUfS.default), {
                    xcss: $6df7f64a9c2aebda$var$styles.pressableStyles,
                    onClick: handleConnectionClick,
                    children: formatMessage($6df7f64a9c2aebda$export$defe85febe8b728c.thirdPartyConnectBannerLink)
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $u9agA.default), {
                alignBlock: "center",
                xcss: $6df7f64a9c2aebda$var$styles.closeButtonContainer,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
                    appearance: "subtle",
                    label: formatMessage($6df7f64a9c2aebda$export$defe85febe8b728c.thirdPartyConnectBannerClose),
                    spacing: "compact",
                    icon: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hmuev))), {
                            label: "Close",
                            size: "medium"
                        }),
                    onClick: ()=>setBannerDismissState({
                            hasBannerBeenDismissed: true
                        }),
                    testId: `${tab}-connect-banner-close-button`
                })
            })
        ]
    });
};
const $6df7f64a9c2aebda$var$ThirdPartyConnectBannerWithAnalytics = (0, $94Xzi.withAnalyticsContext)($6df7f64a9c2aebda$var$ThirdPartyConnectBanner);
const $6df7f64a9c2aebda$export$b1f2280697dd9c14 = (cloudId)=>{
    if (!cloudId) return null;
    return /*#__PURE__*/ (0, $l998X.jsx)($6df7f64a9c2aebda$var$ThirdPartyConnectBannerWithAnalytics, {
        cloudId: cloudId,
        source: "google_drive"
    });
};
const $6df7f64a9c2aebda$export$ddc5f0e2e4d3ba54 = (cloudId)=>{
    if (!cloudId) return null;
    return /*#__PURE__*/ (0, $l998X.jsx)($6df7f64a9c2aebda$var$ThirdPartyConnectBannerWithAnalytics, {
        cloudId: cloudId,
        source: "onedrive"
    });
};
module.exports["renderGoogleDriveConnectBanner"] = $6df7f64a9c2aebda$export$b1f2280697dd9c14;
module.exports["renderOneDriveConnectBanner"] = $6df7f64a9c2aebda$export$ddc5f0e2e4d3ba54;

});

parcelRegister("4kI6d", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* TODO(ASIMO-2105): cherrera2@ to remove once experiment is over regardless of outcome */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $inPa6 = parcelRequire("inPa6");


var $ccHMk = parcelRequire("ccHMk");


var $7hXDW = parcelRequire("7hXDW");


var $2Nwuj = parcelRequire("2Nwuj");


var $gdv5Z = parcelRequire("gdv5Z");

var $iXCQx = parcelRequire("iXCQx");


var $94Xzi = parcelRequire("94Xzi");


var $9HfcQ = parcelRequire("9HfcQ");


var $ilwFS = parcelRequire("ilwFS");


var $aAc08 = parcelRequire("aAc08");

/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* TODO(ASIMO-2105): cherrera2@ to remove once experiment is over regardless of outcome */ 


parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $0b88f5fc8496cd1f$var$thirdPartyIconStyles = null;
const $0b88f5fc8496cd1f$export$f3d49dd29c9236d8 = ()=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        width: "107",
        height: "97",
        viewBox: "0 0 107 97",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: (0, $gMc0m.default)([
            "_19pkutpp _otyrpxbi"
        ]),
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                width: "64",
                height: "64",
                transform: "translate(20 16)",
                fill: "white",
                fillOpacity: "0.01"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                width: "64",
                height: "64",
                transform: "translate(20 16)",
                fill: "white",
                fillOpacity: "0.01"
            }),
            /*#__PURE__*/ (0, $l998X.jsxs)("g", {
                clipPath: "url(#clip0_206_1000)",
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M8.06415 83.3619L12.7682 91.4871C13.7457 93.1977 15.1508 94.5417 16.8003 95.5192L33.6006 66.4394H0C0 68.3332 0.488736 70.2271 1.46621 71.9377L8.06415 83.3619Z",
                        fill: "#0066DA"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M53.3333 32.2282L36.533 3.14838C34.8835 4.12585 33.4784 5.46987 32.501 7.18045L1.46621 60.9414C0.506713 62.6151 0.00127751 64.5105 0 66.4397H33.6006L53.3333 32.2282Z",
                        fill: "#00AC47"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M89.866 95.5192C91.5155 94.5417 92.9206 93.1977 93.8981 91.4871L95.853 88.1271L105.2 71.9377C106.178 70.2271 106.666 68.3332 106.666 66.4394H73.0632L80.2134 80.4906L89.866 95.5192Z",
                        fill: "#EA4335"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M53.3335 32.2279L70.1338 3.14809C68.4843 2.17062 66.5905 1.68188 64.6355 1.68188H42.0315C40.0765 1.68188 38.1827 2.23171 36.5332 3.14809L53.3335 32.2279Z",
                        fill: "#00832D"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M73.0658 66.4394H33.6004L16.8 95.5192C18.4495 96.4967 20.3434 96.9854 22.2983 96.9854H84.3678C86.3228 96.9854 88.2166 96.4356 89.8661 95.5192L73.0658 66.4394Z",
                        fill: "#2684FC"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M89.683 34.0609L74.1656 7.18045C73.1882 5.46987 71.783 4.12585 70.1336 3.14838L53.3333 32.2282L73.066 66.4397H106.605C106.605 64.5459 106.117 62.652 105.139 60.9414L89.683 34.0609Z",
                        fill: "#FFBA00"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("defs", {
                children: /*#__PURE__*/ (0, $l998X.jsx)("clipPath", {
                    id: "clip0_206_1000",
                    children: /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                        width: "106.667",
                        height: "95.3036",
                        fill: "white",
                        transform: "translate(0 1.68195)"
                    })
                })
            })
        ]
    });
};
const $0b88f5fc8496cd1f$export$8428da29d82dbb17 = ()=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        width: "96",
        height: "96",
        viewBox: "0 0 96 96",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M39.4555 36.8091L39.4562 36.8066L54.5709 45.8601L63.5775 42.07C65.4077 41.2788 67.3811 40.8731 69.375 40.875C69.7072 40.875 70.0356 40.8901 70.3623 40.9119C69.2794 36.6896 66.9935 32.8727 63.7823 29.925C60.5711 26.9773 56.5729 25.0258 52.2735 24.3076C47.9742 23.5894 43.5587 24.1354 39.5638 25.8792C35.5689 27.6231 32.1665 30.4897 29.77 34.1308C29.847 34.1299 29.9228 34.125 30 34.125C33.3405 34.1205 36.6156 35.0502 39.4555 36.8091Z",
                fill: "#0364B8"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M39.4562 36.8066L39.4555 36.8091C36.6156 35.0502 33.3405 34.1205 30 34.125C29.9228 34.125 29.8469 34.1299 29.77 34.1308C26.5005 34.1713 23.3039 35.102 20.5236 36.8227C17.7433 38.5435 15.4845 40.9894 13.9898 43.8975C12.4952 46.8056 11.8213 50.066 12.0405 53.3284C12.2597 56.5908 13.3637 59.7317 15.234 62.4138L28.563 56.8047L34.4882 54.3113L47.6811 48.7595L54.5709 45.8602L39.4562 36.8066Z",
                fill: "#0078D4"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M70.3623 40.9119C70.0356 40.8901 69.7072 40.875 69.375 40.875C67.3811 40.8731 65.4081 41.2803 63.5779 42.0715L54.5709 45.8602L57.1827 47.4245L65.7437 52.5525L69.4789 54.7899L82.2507 62.44C83.4112 60.2857 84.0126 57.8746 83.9998 55.4276C83.987 52.9806 83.3605 50.5759 82.1775 48.4338C80.9946 46.2917 79.2931 44.4807 77.2289 43.1665C75.1647 41.8524 72.8037 41.0772 70.3623 40.9119Z",
                fill: "#1490DF"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M69.479 54.7898L65.7438 52.5525L57.1827 47.4245L54.5709 45.8601L47.6811 48.7594L34.4882 54.3112L28.563 56.8046L15.234 62.4137C16.8904 64.7951 19.0985 66.7403 21.6698 68.0831C24.2411 69.426 27.0992 70.1265 30 70.125H69.375C72.0151 70.1258 74.6061 69.4118 76.873 68.0587C79.14 66.7056 80.9983 64.764 82.2507 62.44L69.479 54.7898Z",
                fill: "#28A8EA"
            })
        ]
    });
};


const $0e6f79bc6db51660$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    noResultsThirdPartyGoogleDriveHeader: {
        id: "fabric.linkPickerAtlassianPlugin.emptyStateNoResultsThirdParty.googleDriveHeading",
        defaultMessage: "Connect your Google account"
    },
    noResultsThirdPartyGoogleDriveDescription: {
        id: "fabric.linkPickerAtlassianPlugin.emptyStateNoResultsThirdParty.googleDriveDescription",
        defaultMessage: "Connect your Google account to make it easier to find, share, and collaborate on work."
    },
    noResultsThirdPartyGoogleDriveAuthorizedHeader: {
        id: "fabric.linkPickerAtlassianPlugin.emptyStateNoResultsThirdParty.googleDriveAuthorizedHeading",
        defaultMessage: "Google Drive is connected to your account"
    },
    noResultsThirdPartyGoogleDrivePrimaryAction: {
        id: "fabric.linkPickerAtlassianPlugin.emptyStateNoResultsThirdParty.googleDrivePrimaryAction",
        defaultMessage: "Connect to Google"
    },
    noResultsThirdPartyOneDriveHeader: {
        id: "fabric.linkPickerAtlassianPlugin.emptyStateNoResultsThirdParty.oneDriveHeading",
        defaultMessage: "Connect your OneDrive account"
    },
    noResultsThirdPartyOneDriveDescription: {
        id: "fabric.linkPickerAtlassianPlugin.emptyStateNoResultsThirdParty.oneDriveDescription",
        defaultMessage: "Connect your OneDrive account to make it easier to find, share, and collaborate on work."
    },
    noResultsThirdPartyOneDriveAuthorizedHeader: {
        id: "fabric.linkPickerAtlassianPlugin.emptyStateNoResultsThirdParty.oneDriveAuthorizedHeading",
        defaultMessage: "OneDrive is connected to your account"
    },
    noResultsThirdPartyOneDrivePrimaryAction: {
        id: "fabric.linkPickerAtlassianPlugin.emptyStateNoResultsThirdParty.oneDrivePrimaryAction",
        defaultMessage: "Connect to OneDrive"
    },
    noResultsThirdPartyAuthorizedDescription: {
        id: "fabric.linkPickerAtlassianPlugin.emptyStateNoResultsThirdParty.authorizedDescription",
        defaultMessage: "As you view and edit files, they will appear here."
    },
    noResultsThirdPartyDescriptionLink: {
        id: "fabric.linkPickerAtlassianPlugin.emptyStateNoResultsThirdParty.descriptionLink",
        defaultMessage: "Read more about Smart Links."
    }
});
const $0e6f79bc6db51660$export$6f057925a406dfbd = 'https://support.atlassian.com/confluence-cloud/docs/what-data-is-sent-and-received-when-pasting-a-smart-link';
const $0e6f79bc6db51660$export$a2b4f255152a6585 = {
    emptyStateNoResultsThirdParty: 'link-picker-empty-state-no-results-third-party',
    emptyStateNoResultsThirdPartyDescription: 'link-picker-empty-state-no-results-third-party-description',
    emptyStateNoResultsThirdPartyDescriptionLink: 'link-picker-empty-state-no-results-third-party-description-link',
    emptyStateNoResultsThirdPartyPrimaryAction: 'link-picker-empty-state-no-results-third-party-primary-action'
};
const $0e6f79bc6db51660$var$styles = {
    emptyStateThirdPartyWrapperStyles: "_y3gn1h6o _p12fko4j _1e0c1txw _1q511ejb _85i5ze3t _bozgoahv _y4tioahv _2lx21bp4 _4cvr1h6o",
    headingContainer: "_85i5pxbi",
    descriptionContainer: "_85i5pxbi",
    actionContainer: "_1e0c1txw _4cvr1h6o _1bah1h6o"
};
var $0e6f79bc6db51660$export$165bf6c90b245257 = /*#__PURE__*/ function(ThirdPartySource) {
    ThirdPartySource["GOOGLE_DRIVE"] = "google_drive";
    ThirdPartySource["ONEDRIVE"] = "onedrive";
    return ThirdPartySource;
}({});
const $0e6f79bc6db51660$var$ThirdPartySourceMapping = {
    ["google_drive"]: {
        authorizedHeadingDescriptor: $0e6f79bc6db51660$export$defe85febe8b728c.noResultsThirdPartyGoogleDriveAuthorizedHeader,
        headingDescriptor: $0e6f79bc6db51660$export$defe85febe8b728c.noResultsThirdPartyGoogleDriveHeader,
        descriptionDescriptor: $0e6f79bc6db51660$export$defe85febe8b728c.noResultsThirdPartyGoogleDriveDescription,
        primaryActionDescriptor: $0e6f79bc6db51660$export$defe85febe8b728c.noResultsThirdPartyGoogleDrivePrimaryAction,
        connectionStatusStorageKey: (0, $ilwFS.GOOGLE_DRIVE_CONNECTION_STATUS_STORAGE_KEY),
        icon: /*#__PURE__*/ (0, $l998X.jsx)((0, $0b88f5fc8496cd1f$export$f3d49dd29c9236d8), {}),
        tab: 'google_drive'
    },
    ["onedrive"]: {
        authorizedHeadingDescriptor: $0e6f79bc6db51660$export$defe85febe8b728c.noResultsThirdPartyOneDriveAuthorizedHeader,
        headingDescriptor: $0e6f79bc6db51660$export$defe85febe8b728c.noResultsThirdPartyOneDriveHeader,
        descriptionDescriptor: $0e6f79bc6db51660$export$defe85febe8b728c.noResultsThirdPartyOneDriveDescription,
        primaryActionDescriptor: $0e6f79bc6db51660$export$defe85febe8b728c.noResultsThirdPartyOneDrivePrimaryAction,
        connectionStatusStorageKey: (0, $ilwFS.ONE_DRIVE_CONNECTION_STATUS_STORAGE_KEY),
        icon: /*#__PURE__*/ (0, $l998X.jsx)((0, $0b88f5fc8496cd1f$export$8428da29d82dbb17), {}),
        tab: 'onedrive'
    }
}; /// Component displayed in link picker when there are no results for third party connector tabs or if the
/// user has not connected their account to the corresponding third party connector.
const $0e6f79bc6db51660$var$EmptyStateNoResultsThirdParty = ({ source: source })=>{
    const { authorizedHeadingDescriptor: authorizedHeadingDescriptor, headingDescriptor: headingDescriptor, descriptionDescriptor: descriptionDescriptor, primaryActionDescriptor: primaryActionDescriptor, connectionStatusStorageKey: connectionStatusStorageKey, icon: icon, tab: tab } = $0e6f79bc6db51660$var$ThirdPartySourceMapping[source];
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const intl = (0, $8C5kA.default)();
    const [integrationDetails, setIntegrationDetails] = (0, $9HfcQ.useBrowserStorage)(connectionStatusStorageKey, null);
    const hasAuthorized = integrationDetails?.isUserOAuthed || false;
    const hasIntegrationDetails = Object.keys(integrationDetails || {}).length > 0;
    const header = intl.formatMessage(hasAuthorized ? authorizedHeadingDescriptor : headingDescriptor);
    const description = intl.formatMessage(hasAuthorized ? $0e6f79bc6db51660$export$defe85febe8b728c.noResultsThirdPartyAuthorizedDescription : descriptionDescriptor);
    const descriptionLink = intl.formatMessage($0e6f79bc6db51660$export$defe85febe8b728c.noResultsThirdPartyDescriptionLink);
    const primaryAction = intl.formatMessage(primaryActionDescriptor);
    const handleBroadcastedOAuthSuccess = (_)=>{
        setIntegrationDetails({
            ...integrationDetails,
            isUserOAuthed: true,
            expirationDate: Date.now() + (0, $ilwFS.DEFAULT_EXPIRATION_FOR_3P_CONNECTION_STATUS)
        });
    }; // If the user has authorized through the the banner and the empty state is rendered, update the UI state.
    (0, $42omo.useEffect)(()=>{
        window.addEventListener((0, $aAc08.THIRD_PARTY_OAUTH_SUCCESS_EVENT), handleBroadcastedOAuthSuccess);
        return ()=>{
            window.removeEventListener((0, $aAc08.THIRD_PARTY_OAUTH_SUCCESS_EVENT), handleBroadcastedOAuthSuccess);
        }; // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const trackEvent = (event)=>{
        createAnalyticsEvent(event).fire((0, $94Xzi.ANALYTICS_CHANNEL));
    };
    const handlePrimaryAction = ()=>{
        if (!integrationDetails || !integrationDetails.outboundAuthUrl) return;
        trackEvent((0, $94Xzi.buildAuthClickedEventPayload)((0, $94Xzi.ThirdPartyAuthSource).EMPTY_STATE_CTA, tab));
        (0, $aAc08.triggerThirdPartyAuthFlow)(integrationDetails.outboundAuthUrl).then(()=>{
            setIntegrationDetails({
                ...integrationDetails,
                isUserOAuthed: true,
                expirationDate: Date.now() + (0, $ilwFS.DEFAULT_EXPIRATION_FOR_3P_CONNECTION_STATUS)
            });
            trackEvent((0, $94Xzi.buildAuthCompletedEventPayload)((0, $94Xzi.ThirdPartyAuthSource).EMPTY_STATE_CTA, tab));
        }).catch((_)=>{
            trackEvent((0, $94Xzi.buildAuthFailedEventPayload)((0, $94Xzi.ThirdPartyAuthSource).EMPTY_STATE_CTA, tab));
        });
    };
    const renderPrimaryAction = ()=>{
        if (hasAuthorized || !hasIntegrationDetails) return null;
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
            xcss: $0e6f79bc6db51660$var$styles.actionContainer,
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $ccHMk.default), {
                appearance: "primary",
                testId: $0e6f79bc6db51660$export$a2b4f255152a6585.emptyStateNoResultsThirdPartyPrimaryAction,
                onClick: handlePrimaryAction,
                children: primaryAction
            })
        });
    };
    const renderDescription = ()=>{
        if (hasAuthorized) return /*#__PURE__*/ (0, $l998X.jsx)("span", {
            "data-testid": $0e6f79bc6db51660$export$a2b4f255152a6585.emptyStateNoResultsThirdPartyDescription,
            children: description
        });
        return /*#__PURE__*/ (0, $l998X.jsxs)("span", {
            "data-testid": $0e6f79bc6db51660$export$a2b4f255152a6585.emptyStateNoResultsThirdPartyDescription,
            children: [
                description,
                ' ',
                /*#__PURE__*/ (0, $l998X.jsx)((0, $2Nwuj.default), {
                    href: $0e6f79bc6db51660$export$6f057925a406dfbd,
                    target: "_blank noreferrer",
                    testId: $0e6f79bc6db51660$export$a2b4f255152a6585.emptyStateNoResultsThirdPartyDescriptionLink,
                    children: descriptionLink
                })
            ]
        });
    };
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
        xcss: $0e6f79bc6db51660$var$styles.emptyStateThirdPartyWrapperStyles,
        children: [
            icon,
            /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                xcss: $0e6f79bc6db51660$var$styles.headingContainer,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $7hXDW.default), {
                    size: "medium",
                    as: "h3",
                    children: header
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                xcss: $0e6f79bc6db51660$var$styles.descriptionContainer,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                    as: "p",
                    children: renderDescription()
                })
            }),
            renderPrimaryAction()
        ]
    });
};
const $0e6f79bc6db51660$export$3e30d42bf5744680 = (0, $94Xzi.withAnalyticsContext)($0e6f79bc6db51660$var$EmptyStateNoResultsThirdParty);
const $0e6f79bc6db51660$export$15dbe1e0c6ea7368 = ()=>/*#__PURE__*/ (0, $l998X.jsx)($0e6f79bc6db51660$var$EmptyStateNoResultsThirdParty, {
        source: "google_drive"
    });
const $0e6f79bc6db51660$export$43a489ea433a91df = ()=>/*#__PURE__*/ (0, $l998X.jsx)($0e6f79bc6db51660$var$EmptyStateNoResultsThirdParty, {
        source: "onedrive"
    });
module.exports["renderGoogleDriveEmptyState"] = $0e6f79bc6db51660$export$15dbe1e0c6ea7368;
module.exports["renderOneDriveEmptyState"] = $0e6f79bc6db51660$export$43a489ea433a91df;

});

parcelRegister("4mvgK", function(module, exports) {
/* TODO(ASIMO-2105): cherrera2@ to remove once experiment is over regardless of outcome */ 
var $ilwFS = parcelRequire("ilwFS");

const $894c5d167057635f$var$GOOGLE_DRIVE_CONNECTORS_SET = new Set([
    'google-drive-connector',
    'smartlinks-connector-gdrive'
]);
const $894c5d167057635f$var$ONEDRIVE_CONNECTORS_SET = new Set([
    'onedrive-connector',
    'sharepoint-connector',
    'smartlinks-connector-onedrive',
    'smartlinks-connector-sharepoint'
]);
var $894c5d167057635f$var$ThirdPartyConnector = /*#__PURE__*/ function(ThirdPartyConnector) {
    ThirdPartyConnector["GOOGLE_DRIVE"] = "google_drive";
    ThirdPartyConnector["ONEDRIVE"] = "onedrive";
    return ThirdPartyConnector;
}($894c5d167057635f$var$ThirdPartyConnector || {});
const $894c5d167057635f$var$THIRD_PARTY_CONNECTORS_MAPPING = {
    ["google_drive"]: {
        connectorSet: $894c5d167057635f$var$GOOGLE_DRIVE_CONNECTORS_SET,
        storageStatusSetter: (0, $ilwFS.setGoogleDriveConnectionStatus)
    },
    ["onedrive"]: {
        connectorSet: $894c5d167057635f$var$ONEDRIVE_CONNECTORS_SET,
        storageStatusSetter: (0, $ilwFS.setOneDriveConnectionStatus)
    }
};
/**
 * Fetches third-party data source connection details for a given cloud instance
 * @param cloudId - The Atlassian cloud instance ID
 * @returns Promise resolving to an array of data source connection details, or empty array on error
 */ const $894c5d167057635f$var$getConnectedDataSourcesForCloudId = async (cloudId)=>{
    let dataSourceConnectionDetails = [];
    try {
        const response = await fetch(`/gateway/api/third-party-configuration/connected-data-sources/${cloudId}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            },
            credentials: 'include'
        });
        if (response.ok) dataSourceConnectionDetails = await response.json();
    } catch (err) {
        console.warn('Error fetching third party configuration in link picker', err);
    }
    return dataSourceConnectionDetails;
};
const $894c5d167057635f$export$b0d3308afe3ec114 = async (cloudId = '', connector)=>{
    if (!cloudId) {
        console.warn('No cloudId provided in link picker');
        return false;
    }
    const { connectorSet: connectorSet, storageStatusSetter: storageStatusSetter } = $894c5d167057635f$var$THIRD_PARTY_CONNECTORS_MAPPING[connector];
    const connectedDataSources = await $894c5d167057635f$var$getConnectedDataSourcesForCloudId(cloudId);
    const matchingConnections = (connectedDataSources || []).filter((dataSource)=>connectorSet.has(dataSource.type));
    // Find the first authorized connection, or fall back to the first available connection.
    const authorizedConnection = matchingConnections.find((connection)=>connection.isUserOAuthed);
    const selectedConnection = authorizedConnection || matchingConnections[0] || undefined;
    storageStatusSetter(selectedConnection);
    return Boolean(authorizedConnection);
};
const $894c5d167057635f$export$18facf8eda1dc90b = async (cloudId = '')=>$894c5d167057635f$export$b0d3308afe3ec114(cloudId, "google_drive");
const $894c5d167057635f$export$41759aaeedbf2760 = async (cloudId = '')=>$894c5d167057635f$export$b0d3308afe3ec114(cloudId, "onedrive");
module.exports["checkIfUserHasAuthorizedGoogleDriveConnector"] = $894c5d167057635f$export$18facf8eda1dc90b;
module.exports["checkIfUserHasAuthorizedOneDriveConnector"] = $894c5d167057635f$export$41759aaeedbf2760;

});

parcelRegister("fsf2T", function(module, exports) {
/* TODO(ASIMO-2105): cherrera2@ to remove once experiment is over regardless of outcome */ /**
 * Retrieves and parses a value from localStorage
 * @param key - The localStorage key to retrieve
 * @returns The parsed value of type T, or null if the key doesn't exist or parsing fails
 */ function $915db1806e0743bc$export$f92dfeb71e9bb569(key) {
    try {
        const value = window.localStorage.getItem(key);
        if (value === null) return null;
        return JSON.parse(value);
    } catch (_) {
        return null;
    }
}
function $915db1806e0743bc$export$8a8216c44337cd5(key, value) {
    try {
        window.localStorage.setItem(key, JSON.stringify(value));
    } catch (_) {
        return;
    }
}
function $915db1806e0743bc$export$fe2d9b4e03920b4c(key) {
    try {
        window.localStorage.removeItem(key);
    } catch (_) {
        return;
    }
}
module.exports["getItem"] = $915db1806e0743bc$export$f92dfeb71e9bb569;
module.exports["setItem"] = $915db1806e0743bc$export$8a8216c44337cd5;
module.exports["removeItem"] = $915db1806e0743bc$export$fe2d9b4e03920b4c;

});

parcelRegister("ilwFS", function(module, exports) {
/* TODO(ASIMO-2105): cherrera2@ to remove once experiment is over regardless of outcome */ 
var $fsf2T = parcelRequire("fsf2T");

const $bd88e6e70888917e$export$fc0e7ccdf3b87be1 = 900000; // 15 minutes in milliseconds
const $bd88e6e70888917e$export$5773211c6a105b04 = 'link-picker-google-drive-experiment-third-party-connection-status';
const $bd88e6e70888917e$export$fb25c5ee9c1f1033 = 'link-picker-google-drive-experiment-third-party-connection-banner';
const $bd88e6e70888917e$export$612d4940ce478ff6 = 'link-picker-onedrive-experiment-third-party-connection-status';
const $bd88e6e70888917e$export$a024df05fdd21eca = 'link-picker-onedrive-experiment-third-party-connection-banner';
const $bd88e6e70888917e$export$de4353405dc6e4ef = (storageKey)=>{
    const status = (0, $fsf2T.getItem)(storageKey);
    // Check if the cached status has expired
    if (status && status.expirationDate <= Date.now()) {
        // Remove expired entry and return null
        (0, $fsf2T.removeItem)(storageKey);
        return null;
    }
    return status;
};
const $bd88e6e70888917e$export$f3f16cae70b0982c = (storageKey, integrationDetails)=>{
    const { isUserOAuthed: isUserOAuthed = false, outboundAuthUrl: outboundAuthUrl = '' } = integrationDetails ?? {};
    const status = {
        // Set expiration time based on current time + default TTL
        expirationDate: Date.now() + $bd88e6e70888917e$export$fc0e7ccdf3b87be1,
        isUserOAuthed: isUserOAuthed,
        outboundAuthUrl: outboundAuthUrl
    };
    (0, $fsf2T.setItem)(storageKey, status);
};
const $bd88e6e70888917e$export$5f1b4ac99e2aae8b = (storageKey)=>{
    const status = (0, $fsf2T.getItem)(storageKey);
    return status ?? null;
};
const $bd88e6e70888917e$export$4957a7f4b7020af0 = (storageKey, hasBannerBeenDismissed)=>{
    (0, $fsf2T.setItem)(storageKey, {
        hasBannerBeenDismissed: hasBannerBeenDismissed
    });
};
const $bd88e6e70888917e$export$d14d7bbee5294be0 = ()=>$bd88e6e70888917e$export$de4353405dc6e4ef($bd88e6e70888917e$export$5773211c6a105b04);
const $bd88e6e70888917e$export$b0362b8b535d9b4b = (integrationDetails)=>$bd88e6e70888917e$export$f3f16cae70b0982c($bd88e6e70888917e$export$5773211c6a105b04, integrationDetails);
const $bd88e6e70888917e$export$797a7e7972601e3b = ()=>$bd88e6e70888917e$export$5f1b4ac99e2aae8b($bd88e6e70888917e$export$fb25c5ee9c1f1033);
const $bd88e6e70888917e$export$39c976ba0abb360f = (hasBannerBeenDismissed)=>$bd88e6e70888917e$export$4957a7f4b7020af0($bd88e6e70888917e$export$fb25c5ee9c1f1033, hasBannerBeenDismissed);
const $bd88e6e70888917e$export$a9de5f375de6295d = ()=>$bd88e6e70888917e$export$de4353405dc6e4ef($bd88e6e70888917e$export$612d4940ce478ff6);
const $bd88e6e70888917e$export$7741ea17017edd03 = (integrationDetails)=>$bd88e6e70888917e$export$f3f16cae70b0982c($bd88e6e70888917e$export$612d4940ce478ff6, integrationDetails);
const $bd88e6e70888917e$export$448b90319c5ae70e = ()=>$bd88e6e70888917e$export$5f1b4ac99e2aae8b($bd88e6e70888917e$export$a024df05fdd21eca);
const $bd88e6e70888917e$export$90ca3659cd69272b = (hasBannerBeenDismissed)=>$bd88e6e70888917e$export$4957a7f4b7020af0($bd88e6e70888917e$export$a024df05fdd21eca, hasBannerBeenDismissed);
module.exports["DEFAULT_EXPIRATION_FOR_3P_CONNECTION_STATUS"] = $bd88e6e70888917e$export$fc0e7ccdf3b87be1;
module.exports["GOOGLE_DRIVE_CONNECTION_STATUS_STORAGE_KEY"] = $bd88e6e70888917e$export$5773211c6a105b04;
module.exports["GOOGLE_DRIVE_CONNECTION_BANNER_STORAGE_KEY"] = $bd88e6e70888917e$export$fb25c5ee9c1f1033;
module.exports["ONE_DRIVE_CONNECTION_STATUS_STORAGE_KEY"] = $bd88e6e70888917e$export$612d4940ce478ff6;
module.exports["ONE_DRIVE_CONNECTION_BANNER_STORAGE_KEY"] = $bd88e6e70888917e$export$a024df05fdd21eca;
module.exports["getGoogleDriveConnectionStatus"] = $bd88e6e70888917e$export$d14d7bbee5294be0;
module.exports["setGoogleDriveConnectionStatus"] = $bd88e6e70888917e$export$b0362b8b535d9b4b;
module.exports["getGoogleDriveConnectionBannerStatus"] = $bd88e6e70888917e$export$797a7e7972601e3b;
module.exports["getOneDriveConnectionStatus"] = $bd88e6e70888917e$export$a9de5f375de6295d;
module.exports["setOneDriveConnectionStatus"] = $bd88e6e70888917e$export$7741ea17017edd03;
module.exports["getOneDriveConnectionBannerStatus"] = $bd88e6e70888917e$export$448b90319c5ae70e;

});

parcelRegister("94Xzi", function(module, exports) {
/* TODO(ASIMO-2105): cherrera2@ to remove once experiment is over regardless of outcome */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $kDuN4 = parcelRequire("kDuN4");

const $030cd12278778ff4$var$THIRD_PARTY_SUBJECT = 'thirdPartyOAuth';
const $030cd12278778ff4$export$85183a312807388d = 'media';
const $030cd12278778ff4$export$fc44104665f4d1e5 = 'linkPicker';
var $030cd12278778ff4$export$db358636ef704474 = /*#__PURE__*/ function(ThirdPartyAuthSource) {
    ThirdPartyAuthSource["CONNECT_BANNER"] = "connect-banner";
    ThirdPartyAuthSource["EMPTY_STATE_CTA"] = "empty-state-cta";
    return ThirdPartyAuthSource;
}({});
const $030cd12278778ff4$export$3221252a04776914 = (authSource, tab)=>({
        action: 'clicked',
        eventType: 'ui',
        actionSubject: $030cd12278778ff4$var$THIRD_PARTY_SUBJECT,
        attributes: {
            tab: tab,
            oAuthSource: authSource
        }
    });
const $030cd12278778ff4$export$a48331e6b4cb8e0a = (authSource, tab)=>({
        action: 'completed',
        eventType: 'track',
        actionSubject: $030cd12278778ff4$var$THIRD_PARTY_SUBJECT,
        attributes: {
            tab: tab,
            oAuthSource: authSource
        }
    });
const $030cd12278778ff4$export$5d098194c315c8a0 = (authSource, tab)=>({
        action: 'failed',
        eventType: 'track',
        actionSubject: $030cd12278778ff4$var$THIRD_PARTY_SUBJECT,
        attributes: {
            tab: tab,
            oAuthSource: authSource
        }
    });
function $030cd12278778ff4$export$ad908fe8c5f15382(WrappedComponent) {
    return (props)=>{
        const onEvent = (0, $42omo.useCallback)((event)=>{
            event.update({
                attributes: {
                    ...event.payload.attributes ?? {}
                }
            });
        }, []);
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $kDuN4.default), {
            channel: $030cd12278778ff4$export$85183a312807388d,
            onEvent: onEvent,
            children: /*#__PURE__*/ (0, $l998X.jsx)(WrappedComponent, {
                ...props
            })
        });
    };
}
module.exports["ANALYTICS_CHANNEL"] = $030cd12278778ff4$export$85183a312807388d;
module.exports["ThirdPartyAuthSource"] = $030cd12278778ff4$export$db358636ef704474;
module.exports["buildAuthClickedEventPayload"] = $030cd12278778ff4$export$3221252a04776914;
module.exports["buildAuthCompletedEventPayload"] = $030cd12278778ff4$export$a48331e6b4cb8e0a;
module.exports["buildAuthFailedEventPayload"] = $030cd12278778ff4$export$5d098194c315c8a0;
module.exports["withAnalyticsContext"] = $030cd12278778ff4$export$ad908fe8c5f15382;

});

parcelRegister("9HfcQ", function(module, exports) {
/* TODO(ASIMO-2105): cherrera2@ to remove once experiment is over regardless of outcome */ 
var $42omo = parcelRequire("42omo");


var $fsf2T = parcelRequire("fsf2T");

function $345edfd9eff8a1be$export$44a88c15cde86dc7(key, initialValue) {
    const [storedValue, setStoredValue] = (0, $42omo.useState)(()=>{
        try {
            const item = (0, $fsf2T.getItem)(key);
            return item ?? initialValue;
        } catch (error) {
            return initialValue;
        }
    });
    const setValue = (value)=>{
        const newValue = {
            ...storedValue,
            ...value
        };
        try {
            setStoredValue(newValue);
            (0, $fsf2T.setItem)(key, newValue);
        } catch (error) {
            return newValue;
        }
    };
    return [
        storedValue,
        setValue
    ];
}
var $345edfd9eff8a1be$export$2e2bcd8739ae039 = $345edfd9eff8a1be$export$44a88c15cde86dc7;
module.exports["useBrowserStorage"] = $345edfd9eff8a1be$export$44a88c15cde86dc7;

});

parcelRegister("aAc08", function(module, exports) {
/* TODO(ASIMO-2105): cherrera2@ to remove once experiment is over regardless of outcome */ const $a9a568f0a77e9e12$export$d985885993b3166f = 'link-picker-third-party-experiment-auth-success';
const $a9a568f0a77e9e12$var$broadcastThirdPartyOauthSuccess = ()=>{
    window.dispatchEvent(new CustomEvent($a9a568f0a77e9e12$export$d985885993b3166f));
};
const $a9a568f0a77e9e12$export$27aa70f958418241 = (startUrl)=>{
    return new Promise((resolve, reject)=>{
        let authWindow = null;
        let authWindowInterval;
        const handleAuthWindowClosed = ()=>{
            if (authWindow && authWindow.closed) {
                finishAuthFlow();
                reject(new Error('The auth window was closed when authorizing through link picker.'));
            }
        };
        const initiateAuthFlow = ()=>{
            window.addEventListener('message', handleAuthWindowMessage);
            authWindow = window.open(startUrl, startUrl);
            authWindowInterval = window.setInterval(handleAuthWindowClosed, 500);
        };
        const finishAuthFlow = ()=>{
            clearInterval(authWindowInterval);
            window.removeEventListener('message', handleAuthWindowMessage);
            if (authWindow) {
                authWindow.close();
                authWindow = null;
            }
        };
        const handleAuthWindowMessage = (event)=>{
            if (event.source !== authWindow) return;
            const { data: data } = event;
            if (typeof data !== 'object') return;
            switch(data.type){
                case 'outbound-auth:success':
                    $a9a568f0a77e9e12$var$broadcastThirdPartyOauthSuccess();
                    finishAuthFlow();
                    resolve();
                    break;
                case 'outbound-auth:failure':
                    finishAuthFlow();
                    reject(new Error(data.message));
                    break;
            }
        };
        initiateAuthFlow();
    });
};
module.exports["THIRD_PARTY_OAUTH_SUCCESS_EVENT"] = $a9a568f0a77e9e12$export$d985885993b3166f;
module.exports["triggerThirdPartyAuthFlow"] = $a9a568f0a77e9e12$export$27aa70f958418241;

});


//# sourceMappingURL=root-component.96140ecc.js.map
